!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define("VX", [], t) : "object" == typeof exports ? exports.VX = t() : e.VX = t();
}(self, function () {
  return (() => {
    "use strict";

    var e = {
        "./node_modules/is-mobile/index.js": e => {
          e.exports = o, e.exports.isMobile = o;
          var t = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i,
            n = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|android|ipad|playbook|silk/i;
          function o(e, o) {
            return o || null === e || "object" != typeof e || (o = e), e || "undefined" == typeof navigator || (e = navigator.userAgent), e && e.headers && "string" == typeof e.headers["user-agent"] && (e = e.headers["user-agent"]), "string" == typeof e && (o || (o = {}), o.tablet ? n.test(e) : t.test(e));
          }
        }
      },
      t = {};
    function n(o) {
      var r = t[o];
      if (void 0 !== r) return r.exports;
      var i = t[o] = {
        exports: {}
      };
      return e[o](i, i.exports, n), i.exports;
    }
    n.n = e => {
      var t = e && e.__esModule ? () => e.default : () => e;
      return n.d(t, {
        a: t
      }), t;
    }, n.d = (e, t) => {
      for (var o in t) n.o(t, o) && !n.o(e, o) && Object.defineProperty(e, o, {
        enumerable: !0,
        get: t[o]
      });
    }, n.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), n.r = e => {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    };
    var o = {};
    return (() => {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      n.r(o), n.d(o, {
        VXPay: () => Ni,
        VXPayConfig: () => B,
        VXPayCurrency: () => on,
        VXPayEnvironment: () => r,
        VXPayFlow: () => f,
        VXPayLanguage: () => a,
        VXPayModalConfig: () => p,
        VXPayNotifications: () => Ri,
        VXPayPaymentHooksConfig: () => So
      });
      var t = function () {
        function t() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);
        }
        var n, o, r;
        return n = t, r = [{
          key: "getAvailable",
          value: function () {
            return [t.LANDING_PAGE, t.CULT_BABES, t.TV_CHAT, t.SLP, t.VXONE_LP, t.VXONE];
          }
        }, {
          key: "getDefault",
          value: function () {
            return t.VXONE;
          }
        }], (o = null) && e(n.prototype, o), r && e(n, r), t;
      }();
      t.LANDING_PAGE = "lp", t.CULT_BABES = "cultbabes", t.TV_CHAT = "tvchat", t.SLP = "slp", t.VXONE_LP = "vxonelp", t.VXONE = "vxone";
      const r = t;
      function i(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var u = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }
        var t, n, o;
        return t = e, o = [{
          key: "getDefault",
          value: function () {
            return e.DE;
          }
        }, {
          key: "getAvailable",
          value: function () {
            return [e.DE, e.EN, e.NL];
          }
        }], (n = null) && i(t.prototype, n), o && i(t, o), e;
      }();
      u.DE = "DE", u.EN = "EN", u.NL = "NL";
      const a = u;
      function s(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var c = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }
        var t, n, o;
        return t = e, o = [{
          key: "getAllowed",
          value: function () {
            return [e.AVS, e.LIMIT, e.LOGIN, e.CHARGE, e.OP_COMPENSATION, e.PASSWORD_RESET, e.PASSWORD_LOST, e.PROMOCODE, e.SCRATCH_CARD, e.TRIAL_VIP_ABO, e.VIP_ABO, e.ABO_OVERVIEW, e.VXTV_ABO, e.SETTINGS, e.CHANGE_CARD, e.CHANGE_LS, e.ONE_CLICK, e.AUTO_RECHARGE, e.SIGNUP, e.MIGRATION, e.TELEGRAM];
          }
        }, {
          key: "getDefault",
          value: function () {
            return e.CHARGE;
          }
        }], (n = null) && s(t.prototype, n), o && s(t, o), e;
      }();
      c.AVS = "avs", c.LIMIT = "limit", c.LOGIN = "login", c.SIGNUP = "login", c.CHARGE = "moneycharge", c.OP_COMPENSATION = "opcompensation", c.AUTO_RECHARGE = "autorecharge", c.PASSWORD_RESET = "pwdreset", c.PASSWORD_LOST = "pwdlost", c.PROMOCODE = "promocode", c.SCRATCH_CARD = "scratchcard", c.TRIAL_VIP_ABO = "trialvipabo", c.VIP_ABO = "vipabo", c.ABO_OVERVIEW = "abooverview", c.VXTV_ABO = "vxtvabo", c.SETTINGS = "vxsettings", c.CHANGE_CARD = "changecc", c.CHANGE_LS = "changels", c.ONE_CLICK = "oneclick", c.MIGRATION = "migration", c.TELEGRAM = "telegram";
      const f = c;
      function l(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var h = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._login = e.YES, this._showHeader = e.YES, this._showTeaser = e.YES, this._showFooter = e.YES, this._support = e.YES, this._showOAuth = e.YES, this._showNL = e.YES, this._neutralHeader = e.NO, this._teaserBonus = e.NO, this._showThank = e.NO, this._showLogo = e.NO, this._showTeaserBar = e.NO, this._parentInFrame = e.NO;
        }
        var t, n, o;
        return t = e, o = [{
          key: "_throwOnInvalid",
          value: function (e) {
            if (!m.isModalConfValOk(e)) throw new TypeError("Value not allowed. Try one of: VXPayModalConfig.YES, VXPayModalConfig.NO");
          }
        }, {
          key: "getAllowed",
          value: function () {
            return [e.YES, e.NO];
          }
        }], (n = [{
          key: "getOptions",
          value: function () {
            return {
              login: this._login,
              showHeader: this._showHeader,
              showTeaser: this._showTeaser,
              showFooter: this._showFooter,
              neutralHeader: this._neutralHeader,
              teaserBonus: this._teaserBonus,
              support: this._support,
              showOAuth: this._showOAuth,
              showNL: this._showNL,
              showThank: this._showThank,
              showLogo: this._showLogo,
              showTeaserBar: this._showTeaserBar,
              parentInFrame: this._parentInFrame
            };
          }
        }, {
          key: "parentInFrame",
          get: function () {
            return this._parentInFrame;
          },
          set: function (t) {
            e._throwOnInvalid(t), this._parentInFrame = t;
          }
        }, {
          key: "login",
          get: function () {
            return this._login;
          },
          set: function (t) {
            e._throwOnInvalid(t), this._login = t;
          }
        }, {
          key: "showHeader",
          get: function () {
            return this._showHeader;
          },
          set: function (t) {
            e._throwOnInvalid(t), this._showHeader = t;
          }
        }, {
          key: "showTeaser",
          get: function () {
            return this._showTeaser;
          },
          set: function (t) {
            e._throwOnInvalid(t), this._showTeaser = t;
          }
        }, {
          key: "showFooter",
          get: function () {
            return this._showFooter;
          },
          set: function (t) {
            e._throwOnInvalid(t), this._showFooter = t;
          }
        }, {
          key: "neutralHeader",
          get: function () {
            return this._neutralHeader;
          },
          set: function (t) {
            e._throwOnInvalid(t), this._neutralHeader = t;
          }
        }, {
          key: "teaserBonus",
          get: function () {
            return this._teaserBonus;
          },
          set: function (t) {
            e._throwOnInvalid(t), this._teaserBonus = t;
          }
        }, {
          key: "support",
          get: function () {
            return this._support;
          },
          set: function (t) {
            e._throwOnInvalid(t), this._support = t;
          }
        }, {
          key: "showOAuth",
          get: function () {
            return this._showOAuth;
          },
          set: function (t) {
            e._throwOnInvalid(t), this._showOAuth = t;
          }
        }, {
          key: "showNL",
          get: function () {
            return this._showNL;
          },
          set: function (t) {
            e._throwOnInvalid(t), this._showNL = t;
          }
        }, {
          key: "showThank",
          get: function () {
            return this._showThank;
          },
          set: function (t) {
            e._throwOnInvalid(t), this._showThank = t;
          }
        }, {
          key: "showLogo",
          get: function () {
            return this._showLogo;
          },
          set: function (t) {
            e._throwOnInvalid(t), this._showLogo = t;
          }
        }, {
          key: "showTeaserBar",
          get: function () {
            return this._showTeaserBar;
          },
          set: function (t) {
            e._throwOnInvalid(t), this._showTeaserBar = t;
          }
        }]) && l(t.prototype, n), o && l(t, o), e;
      }();
      h.YES = 1, h.NO = 0;
      const p = h;
      function y(e) {
        return y = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, y(e);
      }
      function _(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }
      function g(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var b = function () {
        function e() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0;
          _(this, e), this._urlImpl = void 0 === t ? window.URL : t;
        }
        var t, n, o;
        return t = e, n = [{
          key: "generate",
          value: function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0,
              n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0,
              o = new this._urlImpl(e);
            if (o.hash = "", t) for (var r in t) {
              var i = t[r];
              void 0 !== i && ("object" === y(i) && (i = JSON.stringify(i)), o.searchParams.append(r, i));
            }
            if (n) for (var u in n) {
              var a = "_" === u.charAt(1) ? u.substr(1) : u;
              void 0 !== n[a] && o.searchParams.append("mc[" + u + "]", n[u]);
            }
            return o.toString();
          }
        }, {
          key: "getQueryParam",
          value: function (e, t) {
            try {
              return new this._urlImpl(e).searchParams[t];
            } catch (e) {
              return "";
            }
          }
        }, {
          key: "isValid",
          value: function (e) {
            try {
              return new this._urlImpl(e), !0;
            } catch (e) {
              return !1;
            }
          }
        }], n && g(t.prototype, n), o && g(t, o), e;
      }();
      function d(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var m = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }
        var t, n, o;
        return t = e, o = [{
          key: "isUrl",
          value: function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0,
              n = new b(t);
            return n.isValid(e);
          }
        }, {
          key: "isLangOk",
          value: function (e) {
            return -1 !== a.getAvailable().indexOf(e);
          }
        }, {
          key: "isEnvOk",
          value: function (e) {
            return -1 !== r.getAvailable().indexOf(e);
          }
        }, {
          key: "isFlowOk",
          value: function (e) {
            return -1 !== f.getAllowed().indexOf(e);
          }
        }, {
          key: "isModalConfValOk",
          value: function (e) {
            return -1 !== p.getAllowed().indexOf(e);
          }
        }], (n = null) && d(t.prototype, n), o && d(t, o), e;
      }();
      function O(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var v = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }
        var t, n, o;
        return t = e, o = [{
          key: "addEvent",
          value: function (t, n, o) {
            n.addEventListener ? n.addEventListener(t, o, {
              passive: !0
            }) : n.attachEvent ? n.attachEvent(e.IE_PREFIX + t, o) : n[t] = o;
          }
        }, {
          key: "removeEvent",
          value: function (t, n, o) {
            n.removeEventListener ? n.removeEventListener(t, o, {
              passive: !0
            }) : n.detachEvent ? n.detachEvent(e.IE_PREFIX + t, o) : n[t] = null;
          }
        }], (n = null) && O(t.prototype, n), o && O(t, o), e;
      }();
      v.IE_PREFIX = "on";
      const w = v;
      function E(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var S = function () {
        function e(t, n, o) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._window = t, this._jQuery = n, this._fx = o;
        }
        var t, n, o;
        return t = e, o = [{
          key: "getClientHeight",
          value: function (e) {
            return e.innerHeight || e.document.documentElement.clientHeight || e.document.body.clientHeight;
          }
        }, {
          key: "isStyleAttributeSuppored",
          value: function (e, t, n) {
            var o = !1;
            try {
              e.style[t] = n, o = e.style[t] === n;
            } catch (e) {}
            return o;
          }
        }], (n = [{
          key: "_hasJQuery",
          value: function () {
            return void 0 !== this._jQuery && void 0 !== this._jQuery.Animation;
          }
        }, {
          key: "_hasMooTools",
          value: function () {
            return void 0 !== this._fx && void 0 !== this._fx.Scroll;
          }
        }, {
          key: "scrollTo",
          value: function (t) {
            try {
              if (this._hasJQuery()) {
                var n = e.OPTIONS_JQUERY;
                return n.scrollTop = t, this._jQuery("html, body").animate(n, e.ANIMATION_DURATION);
              }
              return this._hasMooTools() ? new this._fx.Scroll(this._window, e.OPTIONS_MTOOLS).start(0, t) : this._window.scrollTo(0, t);
            } catch (e) {}
          }
        }, {
          key: "window",
          get: function () {
            return this._window;
          }
        }, {
          key: "jQuery",
          get: function () {
            return this._jQuery;
          }
        }, {
          key: "fx",
          get: function () {
            return this._fx;
          }
        }]) && E(t.prototype, n), o && E(t, o), e;
      }();
      S.TAG_IFRAME = "iframe", S.OPTIONS_JQUERY = {
        scrollTop: 0
      }, S.OPTIONS_MTOOLS = {
        duration: S.ANIMATION_DURATION
      }, S.ANIMATION_DURATION = 500;
      const T = S;
      function k(e) {
        return k = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, k(e);
      }
      function A(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }
      function P(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      function I(e, t) {
        return !t || "object" !== k(t) && "function" != typeof t ? R(e) : t;
      }
      function N(e) {
        return N = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, N(e);
      }
      function C(e, t) {
        return C = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, C(e, t);
      }
      function R(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }
      var F = function (e) {
        function t(e, n, o) {
          var r,
            i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
          if (A(this, t), r = I(this, N(t).call(this)), "function" != typeof e.createElement) throw new TypeError("An iFrame can only be build on a valid Document object!");
          if (!m.isUrl(n, e.defaultView.URL)) throw new TypeError("Please provide a valid URL! " + n);
          if (!o || 0 === o.length) throw new TypeError("Please provide a valid frame ID!");
          if (r._loaded = !1, r._frame = e.createElement(T.TAG_IFRAME), r._frame.src = n, r._frame.id = o, r._frame.onload = r._markLoaded.bind(R(R(r))), null !== i) for (var u in i) r._frame.style[u] = i[u];
          return r;
        }
        var n, o, r;
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && C(e, t);
        }(t, e), n = t, o = [{
          key: "triggerLoad",
          value: function () {
            throw new Error("Method triggerLoad should be implemented in child class!");
          }
        }, {
          key: "_markLoaded",
          value: function () {
            this._loaded = !0;
          }
        }, {
          key: "maximize",
          value: function () {
            return this._frame.style.width = t.MAX_WIDTH, this._frame.style.height = t.MAX_HEIGHT, this._frame.style.left = t.MAX_LEFT, this._frame.style.top = t.MAX_TOP, this._frame.style.marginLeft = t.MAX_LEFT_MARGIN, this;
          }
        }, {
          key: "message",
          value: function () {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t.ORIGIN_ALL;
            return this._frame.contentWindow.postMessage(e.toString(), n), this;
          }
        }, {
          key: "show",
          value: function () {
            this._frame.style.display = t.DISPLAY_BLOCK;
          }
        }, {
          key: "hide",
          value: function () {
            this._frame.style.display = t.DISPLAY_NONE;
          }
        }, {
          key: "loaded",
          get: function () {
            return this._loaded;
          }
        }, {
          key: "frame",
          get: function () {
            return this._frame;
          }
        }, {
          key: "url",
          set: function (e) {
            this._frame.src = e;
          },
          get: function () {
            return this._frame.src;
          }
        }], o && P(n.prototype, o), r && P(n, r), t;
      }(w);
      F.EVENT_MESSAGE = "message", F.EVENT_LOAD = "load", F.EVENT_UNLOAD = "beforeunload", F.POSITION_ABSOLUTE = "absolute", F.POSITION_FIXED = "fixed", F.DISPLAY_BLOCK = "block", F.DISPLAY_NONE = "none", F.MAX_HEIGHT = "100vh", F.MAX_WIDTH = "100%", F.MAX_TOP = "0", F.MAX_LEFT = "0", F.MAX_LEFT_MARGIN = "0", F.ORIGIN_VX = "https://www.visit-x.net", F.ORIGIN_ALL = "*";
      const L = F;
      var j = n("./node_modules/is-mobile/index.js"),
        V = n.n(j);
      function D(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }
      function M(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var U = function () {
        function e() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
          D(this, e), this._userAgent = t;
        }
        var t, n, o;
        return t = e, (n = [{
          key: "isMobile",
          value: function () {
            return V()(this._userAgent);
          }
        }, {
          key: "userAgent",
          get: function () {
            return this._userAgent;
          },
          set: function (e) {
            this._userAgent = e;
          }
        }]) && M(t.prototype, n), o && M(t, o), e;
      }();
      function G(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }
      function H(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var x = function () {
        function e(t) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0,
            o = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
          G(this, e), this._env = r.getDefault(), this._logging = o, this._flow = f.getDefault(), this._language = a.getDefault(), this._urls = {
            agb: e.AGB_DEFAULT.replace("{language}", this._language),
            privacy: e.PRIVACY_DEFAULT.replace("{language}", this._language),
            ref: "",
            ruri: "",
            suri: "",
            successUrl: "",
            purl: ""
          }, this._pfm = "", this._pfmsub = "", this._enableTab = new U(t.navigator.userAgent || "").isMobile(), this._host = "", this._token = "", this._promoCode = "", this._wmId = "", this._wmSubRef = "", this._wmToken = "", this._adtv = "", this._subRef = "", this._apiVersion = 3, this._flowParams = {}, this._modalConfig = void 0 === n ? new p() : n, this._window = t, this._helper = new b(t.URL);
        }
        var t, n, o;
        return t = e, n = [{
          key: "getPaymentFrameUrl",
          value: function () {
            return this._helper.generate(L.ORIGIN_VX + "/VXPAY-V" + this._apiVersion + "/", this.getOptions(), this._modalConfig.getOptions());
          }
        }, {
          key: "getOptions",
          value: function () {
            return {
              agbUrl: this.agbUrl,
              privacyUrl: this.privacyUrl,
              environment: this._env,
              flow: this._flow,
              lang: this._language,
              pfm: this._pfm,
              pfmsub: this._pfmsub,
              w: this._wmId,
              ws: this._wmSubRef,
              wt: this._wmToken,
              adtv: this._adtv,
              sub: this._subRef,
              enableTab: this._enableTab ? 1 : 0,
              option: "",
              pc: this._promoCode,
              tt: this._token,
              ruri: this._urls.ruri,
              successUrl: this._urls.successUrl,
              host: this._host,
              flowParams: this._flowParams
            };
          }
        }, {
          key: "getAdditionalOptions",
          value: function () {
            var e = {
              ref: this._urls.ref,
              ruri: this._urls.ruri,
              surl: this._urls.suri,
              aurl: this.agbUrl,
              prurl: this.privacyUrl,
              purl: this._urls.purl
            };
            return Object.assign({}, e, this.modalConfig.getOptions());
          }
        }, {
          key: "setTokenFromMessage",
          value: function (e) {
            this._token = e.token;
          }
        }, {
          key: "merge",
          value: function () {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = this;
            Object.keys(t.getOptions()).forEach(function (n) {
              var o = void 0 !== e[n];
              "lang" === n && void 0 !== e.language ? t[n] = e.language : o && (t[n] = e[n]);
            });
          }
        }, {
          key: "updateFlow",
          value: function (e) {
            this._flow = e.newFlow;
          }
        }, {
          key: "ruri",
          get: function () {
            return this._urls.ruri;
          },
          set: function (e) {
            this._urls.ruri = e;
          }
        }, {
          key: "ref",
          get: function () {
            return this._urls.ref;
          },
          set: function (e) {
            this._urls.ref = e;
          }
        }, {
          key: "suri",
          get: function () {
            return this._urls.suri;
          }
        }, {
          key: "successUrl",
          get: function () {
            return this._urls.successUrl;
          },
          set: function (e) {
            this._urls.successUrl = e;
          }
        }, {
          key: "purl",
          get: function () {
            return this._urls.purl;
          }
        }, {
          key: "window",
          get: function () {
            return this._window;
          }
        }, {
          key: "agbUrl",
          get: function () {
            return this._urls.agb;
          },
          set: function (e) {
            if (!m.isUrl(e)) throw new Error("Invalid URL provided: " + e);
            this._urls.agb = e;
          }
        }, {
          key: "privacyUrl",
          get: function () {
            return this._urls.privacy;
          },
          set: function (e) {
            if (!m.isUrl(e)) throw new Error("Invalid URL provided: " + e);
            this._urls.privacy = e;
          }
        }, {
          key: "env",
          get: function () {
            return this._env;
          },
          set: function (e) {
            if (!m.isEnvOk(e)) throw new TypeError("Environment " + e + " is not supported. Please select one of " + r.getAvailable());
            this._env = e;
          }
        }, {
          key: "logging",
          get: function () {
            return this._logging;
          },
          set: function (e) {
            this._logging = e;
          }
        }, {
          key: "language",
          get: function () {
            return this._language.toUpperCase();
          },
          set: function (e) {
            if (!m.isLangOk(e)) {
              var t = "Unsupported language: " + e.toString() + ". Allowed: " + a.getAvailable().join(", ");
              throw new TypeError(t);
            }
            this._language = e;
          }
        }, {
          key: "flow",
          get: function () {
            return this._flow;
          },
          set: function (e) {
            if (!m.isFlowOk(e)) {
              var t = "Flow not allowed: " + e.toString() + ". Select one of: " + f.getAllowed().join(", ");
              throw new TypeError(t);
            }
            this._flow = e;
          }
        }, {
          key: "host",
          get: function () {
            return this._host;
          },
          set: function (e) {
            this._host = e;
          }
        }, {
          key: "token",
          get: function () {
            return this._token;
          },
          set: function (e) {
            this._token = e;
          }
        }, {
          key: "promoCode",
          get: function () {
            return this._promoCode;
          },
          set: function (e) {
            this._promoCode = e;
          }
        }, {
          key: "wmId",
          get: function () {
            return this._wmId;
          },
          set: function (e) {
            this._wmId = e;
          }
        }, {
          key: "wmSubRef",
          get: function () {
            return this._wmSubRef;
          },
          set: function (e) {
            this._wmSubRef = e;
          }
        }, {
          key: "wmToken",
          get: function () {
            return this._wmToken;
          },
          set: function (e) {
            this._wmToken = e;
          }
        }, {
          key: "adtv",
          get: function () {
            return this._adtv;
          },
          set: function (e) {
            this._adtv = e;
          }
        }, {
          key: "subRef",
          get: function () {
            return this._subRef;
          },
          set: function (e) {
            this._subRef = e;
          }
        }, {
          key: "apiVersion",
          get: function () {
            return this._apiVersion;
          },
          set: function (e) {
            this._apiVersion = parseInt(e, 10);
          }
        }, {
          key: "modalConfig",
          get: function () {
            return this._modalConfig;
          },
          set: function (e) {
            if (!(e instanceof p)) throw new TypeError("Modal config value should be instance of VXPayModalConfig!");
            this._modalConfig = e;
          }
        }, {
          key: "pfm",
          get: function () {
            return this._pfm;
          },
          set: function (e) {
            this._pfm = e;
          }
        }, {
          key: "pfmsub",
          get: function () {
            return this._pfmsub;
          },
          set: function (e) {
            this._pfmsub = e;
          }
        }, {
          key: "enableTab",
          get: function () {
            return this._enableTab;
          },
          set: function (e) {
            this._enableTab = e;
          }
        }, {
          key: "flowParams",
          get: function () {
            return this._flowParams;
          },
          set: function (e) {
            this._flowParams = e;
          }
        }], n && H(t.prototype, n), o && H(t, o), e;
      }();
      x.AGB_DEFAULT = "https://www.visit-x.net/CAMS/{language}/Info/Zentrum.html?submod=AGB&track=Account", x.PRIVACY_DEFAULT = "https://www.visit-x.net/CAMS/{language}/Info/Zentrum.html?submod=Datenschutz&track=Index";
      const B = x;
      function X(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }
      function Y(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var W = function () {
        function e(t) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
          X(this, e), this.enabled = t || !1, this._container = [], this._window = n;
        }
        var t, n, o;
        return t = e, n = [{
          key: "log",
          value: function () {
            if (this.enabled) return void 0 !== this._window ? this._window.console.log.apply(this, arguments) : void this._container.push({
              time: new Date(),
              message: JSON.stringify(arguments)
            });
          }
        }], n && Y(t.prototype, n), o && Y(t, o), e;
      }();
      W.IN = "⬅️ []", W.OUT = "➡️ []";
      const K = W;
      function Q(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }
      function z(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var J = function () {
        function e() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
          Q(this, e), this.type = t, this.isAction = !1;
        }
        var t, n, o;
        return t = e, (n = [{
          key: "toString",
          value: function () {
            return JSON.stringify(this);
          }
        }]) && z(t.prototype, n), o && z(t, o), e;
      }();
      J.T_HOOK = "modalbox-hook", J.T_SCROLL = "modalbox-scrollto", J.T_SUCCESS = "modalbox-success", J.T_IFR_CLOSE = "modalbox-iframe-close", J.T_IFR_RDY = "modalbox-iframe-ready", J.T_VIEW_RDY = "modalbox-view-ready", J.T_TOKEN = "modalbox-transfer-token", J.T_CONTENT = "modalbox-content-loaded", J.T_SESSION = "modalbox-init-session", J.T_PARAMS = "modalbox-update-params", J.T_VISIBLE = "modalbox-is-visible", J.T_INFO = "modalbox-additional-info", J.T_ROUTE = "modalbox-change-route", J.T_COOKIE = "modalbox-response-hasLoginCookie", J.T_IS_LOGGED = "modalbox-response-isLoggedIn", J.T_AVS = "modalbox-response-getavsstatus", J.T_BALANCE = "modalbox-response-getbalance", J.T_ABOS = "modalbox-response-getactiveabos", J.T_LOGGED_OUT = "modalbox-response-logout", J.TA_ABOS = "modalbox-action-getactiveabos", J.TA_LOGOUT = "modalbox-action-logout", J.TA_AVS = "modalbox-action-getavsstatus", J.TA_IS_LOGGED = "modalbox-action-isLoggedIn", J.TA_BALANCE = "modalbox-action-getbalance", J.TT_PREFIX = "transfer_token:";
      const Z = J;
      function q(e) {
        return q = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, q(e);
      }
      function $(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }
      function ee(e, t) {
        return !t || "object" !== q(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }
      function te(e) {
        return te = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, te(e);
      }
      function ne(e, t) {
        return ne = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, ne(e, t);
      }
      var oe = function (e) {
        function t() {
          var e,
            n = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          return $(this, t), (e = ee(this, te(t).call(this, Z.T_COOKIE))).hasCookie = n, e;
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && ne(e, t);
        }(t, e), t;
      }(Z);
      function re(e) {
        return re = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, re(e);
      }
      function ie(e, t) {
        return !t || "object" !== re(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }
      function ue(e) {
        return ue = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, ue(e);
      }
      function ae(e, t) {
        return ae = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, ae(e, t);
      }
      var se = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), ie(this, ue(t).call(this, Z.T_CONTENT));
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && ae(e, t);
        }(t, e), t;
      }(Z);
      function ce(e) {
        return ce = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, ce(e);
      }
      function fe(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }
      function le(e, t) {
        return !t || "object" !== ce(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }
      function he(e) {
        return he = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, he(e);
      }
      function pe(e, t) {
        return pe = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, pe(e, t);
      }
      var ye = function (e) {
        function t() {
          var e,
            n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : t.H_NA;
          return fe(this, t), (e = le(this, he(t).call(this, Z.T_HOOK))).hook = n, e;
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && pe(e, t);
        }(t, e), t;
      }(Z);
      ye.H_NA = "dummy-unknown", ye.H_FLOW = "flowChanged", ye.H_LOGIN = "login", ye.H_PAYMENT = "payment", ye.H_SIGNUP = "signup", ye.H_C_SETTINGS = "comfortSettingsChanged", ye.H_E_VERIFIED = "emailVerified", ye.H_E_NOT_VERIFIED = "emailNotVerified", ye.H_PASS = "passwordChanged";
      const _e = ye;
      function ge(e) {
        return ge = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, ge(e);
      }
      function be(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }
      function de(e, t) {
        return !t || "object" !== ge(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }
      function me(e) {
        return me = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, me(e);
      }
      function Oe(e, t) {
        return Oe = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, Oe(e, t);
      }
      var ve = function (e) {
        function t() {
          var e,
            n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
            o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
          return be(this, t), (e = de(this, me(t).call(this, _e.H_FLOW))).oldFlow = n, e.newFlow = o, e;
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && Oe(e, t);
        }(t, e), t;
      }(_e);
      function we(e) {
        return we = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, we(e);
      }
      function Ee(e, t) {
        return !t || "object" !== we(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }
      function Se(e) {
        return Se = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, Se(e);
      }
      function Te(e, t) {
        return Te = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, Te(e, t);
      }
      var ke = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), Ee(this, Se(t).call(this, _e.H_LOGIN));
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && Te(e, t);
        }(t, e), t;
      }(_e);
      function Ae(e) {
        return Ae = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, Ae(e);
      }
      function Pe(e, t) {
        return !t || "object" !== Ae(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }
      function Ie(e) {
        return Ie = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, Ie(e);
      }
      function Ne(e, t) {
        return Ne = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, Ne(e, t);
      }
      var Ce = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), Pe(this, Ie(t).call(this, _e.H_PAYMENT));
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && Ne(e, t);
        }(t, e), t;
      }(_e);
      function Re(e) {
        return Re = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, Re(e);
      }
      function Fe(e, t) {
        return !t || "object" !== Re(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }
      function Le(e) {
        return Le = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, Le(e);
      }
      function je(e, t) {
        return je = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, je(e, t);
      }
      var Ve = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), Fe(this, Le(t).call(this, _e.H_SIGNUP));
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && je(e, t);
        }(t, e), t;
      }(_e);
      function De(e) {
        return De = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, De(e);
      }
      function Me(e, t) {
        return !t || "object" !== De(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }
      function Ue(e) {
        return Ue = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, Ue(e);
      }
      function Ge(e, t) {
        return Ge = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, Ge(e, t);
      }
      var He = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), Me(this, Ue(t).call(this, _e.H_C_SETTINGS));
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && Ge(e, t);
        }(t, e), t;
      }(_e);
      function xe(e) {
        return xe = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, xe(e);
      }
      function Be(e, t) {
        return !t || "object" !== xe(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }
      function Xe(e) {
        return Xe = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, Xe(e);
      }
      function Ye(e, t) {
        return Ye = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, Ye(e, t);
      }
      var We = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), Be(this, Xe(t).call(this, _e.H_E_VERIFIED));
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && Ye(e, t);
        }(t, e), t;
      }(_e);
      function Ke(e) {
        return Ke = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, Ke(e);
      }
      function Qe(e, t) {
        return !t || "object" !== Ke(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }
      function ze(e) {
        return ze = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, ze(e);
      }
      function Je(e, t) {
        return Je = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, Je(e, t);
      }
      var Ze = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), Qe(this, ze(t).call(this, _e.H_E_NOT_VERIFIED));
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && Je(e, t);
        }(t, e), t;
      }(_e);
      function qe(e) {
        return qe = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, qe(e);
      }
      function $e(e, t) {
        return !t || "object" !== qe(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }
      function et(e) {
        return et = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, et(e);
      }
      function tt(e, t) {
        return tt = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, tt(e, t);
      }
      var nt = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), $e(this, et(t).call(this, _e.H_PASS));
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && tt(e, t);
        }(t, e), t;
      }(_e);
      function ot(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var rt = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }
        var t, n, o;
        return t = e, o = [{
          key: "fromData",
          value: function () {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            if (void 0 === e || !e.hook) throw new TypeError("Invalid message format - no hook field");
            switch (e.hook) {
              case _e.H_FLOW:
                return new ve(e.prevFlow, e.flow);
              case _e.H_LOGIN:
                return new ke();
              case _e.H_PAYMENT:
                return new Ce();
              case _e.H_SIGNUP:
                return new Ve();
              case _e.H_C_SETTINGS:
                return new He();
              case _e.H_E_VERIFIED:
                return new We();
              case _e.H_E_NOT_VERIFIED:
                return new Ze();
              case _e.H_PASS:
                return new nt();
              default:
                return new _e();
            }
          }
        }], (n = null) && ot(t.prototype, n), o && ot(t, o), e;
      }();
      function it(e) {
        return it = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, it(e);
      }
      function ut(e, t) {
        return !t || "object" !== it(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }
      function at(e) {
        return at = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, at(e);
      }
      function st(e, t) {
        return st = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, st(e, t);
      }
      var ct = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), ut(this, at(t).call(this, Z.T_IFR_RDY));
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && st(e, t);
        }(t, e), t;
      }(Z);
      function ft(e) {
        return ft = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, ft(e);
      }
      function lt(e, t) {
        return !t || "object" !== ft(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }
      function ht(e) {
        return ht = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, ht(e);
      }
      function pt(e, t) {
        return pt = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, pt(e, t);
      }
      var yt = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), lt(this, ht(t).call(this, Z.T_VIEW_RDY));
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && pt(e, t);
        }(t, e), t;
      }(Z);
      function _t(e) {
        return _t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, _t(e);
      }
      function gt(e, t) {
        return !t || "object" !== _t(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }
      function bt(e) {
        return bt = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, bt(e);
      }
      function dt(e, t) {
        return dt = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, dt(e, t);
      }
      var mt = function (e) {
        function t(e) {
          var n;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), (n = gt(this, bt(t).call(this, Z.T_TOKEN))).token = e, n;
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && dt(e, t);
        }(t, e), t;
      }(Z);
      function Ot(e) {
        return Ot = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, Ot(e);
      }
      function vt(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }
      function wt(e, t) {
        return !t || "object" !== Ot(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }
      function Et(e) {
        return Et = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, Et(e);
      }
      function St(e, t) {
        return St = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, St(e, t);
      }
      var Tt = function (e) {
        function t() {
          var e,
            n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return vt(this, t), (e = wt(this, Et(t).call(this, Z.T_IFR_CLOSE))).data = n, e;
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && St(e, t);
        }(t, e), t;
      }(Z);
      function kt(e) {
        return kt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, kt(e);
      }
      function At(e, t) {
        return !t || "object" !== kt(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }
      function Pt(e) {
        return Pt = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, Pt(e);
      }
      function It(e, t) {
        return It = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, It(e, t);
      }
      var Nt = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), At(this, Pt(t).call(this, Z.T_VISIBLE));
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && It(e, t);
        }(t, e), t;
      }(Z);
      function Ct(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      const Rt = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._balance = NaN, this._fsk18 = !1, this._nickname = "", this._userId = NaN, this._uhash = "", this._services = {};
        }
        var t, n, o;
        return t = e, (n = [{
          key: "balance",
          get: function () {
            return this._balance;
          },
          set: function (e) {
            this._balance = e;
          }
        }, {
          key: "fsk18",
          get: function () {
            return this._fsk18;
          },
          set: function (e) {
            this._fsk18 = e;
          }
        }, {
          key: "nickname",
          get: function () {
            return this._nickname;
          },
          set: function (e) {
            this._nickname = e;
          }
        }, {
          key: "userId",
          get: function () {
            return this._userId;
          },
          set: function (e) {
            this._userId = e;
          }
        }, {
          key: "uhash",
          get: function () {
            return this._uhash;
          },
          set: function (e) {
            this._uhash = e;
          }
        }, {
          key: "services",
          get: function () {
            return this._services;
          },
          set: function (e) {
            this._services = e;
          }
        }]) && Ct(t.prototype, n), o && Ct(t, o), e;
      }();
      function Ft(e) {
        return Ft = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, Ft(e);
      }
      function Lt(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }
      function jt(e, t) {
        return !t || "object" !== Ft(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }
      function Vt(e) {
        return Vt = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, Vt(e);
      }
      function Dt(e, t) {
        return Dt = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, Dt(e, t);
      }
      var Mt = function (e) {
        function t() {
          var e,
            n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : t.USER_DATA_STRUCT;
          return Lt(this, t), (e = jt(this, Vt(t).call(this, Z.T_SUCCESS))).user = new Rt(), e.user.balance = n.availableMoney || 0, e.user.nickname = n.screenname || "", e.user.fsk18 = n.fsk18 || !1, e.user.userId = n.userId || NaN, e.user.uhash = n.uhash || "", e.user.services = n.services || {}, e;
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && Dt(e, t);
        }(t, e), t;
      }(Z);
      Mt.USER_DATA_STRUCT = {
        success: !0,
        userFromLogin: !1,
        userFromSignup: !1,
        flow: "login",
        hostId: null,
        screenname: "user123",
        userId: 9876789087,
        isLoggedIn: !0,
        transferToken: "TT_7a9523c9-5555-4c48-5555-91cc2465f484",
        availableMoney: 12.34,
        fsk18: !1,
        uhash: "",
        services: {}
      };
      const Ut = Mt;
      function Gt(e) {
        return Gt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, Gt(e);
      }
      function Ht(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }
      function xt(e, t) {
        return !t || "object" !== Gt(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }
      function Bt(e) {
        return Bt = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, Bt(e);
      }
      function Xt(e, t) {
        return Xt = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, Xt(e, t);
      }
      var Yt = function (e) {
        function t() {
          var e,
            n = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          return Ht(this, t), (e = xt(this, Bt(t).call(this, Z.T_IS_LOGGED))).loggedIn = n, e;
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && Xt(e, t);
        }(t, e), t;
      }(Z);
      const Wt = Yt;
      function Kt(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var Qt = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._fsk18 = !1;
        }
        var t, n, o;
        return t = e, o = [{
          key: "fromData",
          value: function () {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              n = new e();
            return n.fsk18 = t.fsk18 || !1, n;
          }
        }], (n = [{
          key: "fsk18",
          get: function () {
            return this._fsk18;
          },
          set: function (e) {
            this._fsk18 = e;
          }
        }]) && Kt(t.prototype, n), o && Kt(t, o), e;
      }();
      function zt(e) {
        return zt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, zt(e);
      }
      function Jt(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }
      function Zt(e, t) {
        return !t || "object" !== zt(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }
      function qt(e) {
        return qt = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, qt(e);
      }
      function $t(e, t) {
        return $t = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, $t(e, t);
      }
      var en = function (e) {
        function t() {
          var e,
            n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Qt();
          return Jt(this, t), (e = Zt(this, qt(t).call(this, Z.T_AVS))).status = n, e;
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && $t(e, t);
        }(t, e), t;
      }(Z);
      function tn(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var nn = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }
        var t, n, o;
        return t = e, o = [{
          key: "getDefault",
          value: function () {
            return e.EUR;
          }
        }, {
          key: "getAllowed",
          value: function () {
            return [e.EUR, e.USD, e.CHF];
          }
        }], (n = null) && tn(t.prototype, n), o && tn(t, o), e;
      }();
      nn.EUR = "EUR", nn.USD = "USD", nn.CHF = "CHF";
      const on = nn;
      function rn(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }
      function un(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var an = function () {
        function e() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : on.EUR;
          rn(this, e), this._amount = t, this._currency = n;
        }
        var t, n, o;
        return t = e, (n = [{
          key: "toString",
          value: function () {
            return this._amount.toFixed(2) + " " + this._currency;
          }
        }, {
          key: "amount",
          get: function () {
            return this._amount;
          }
        }, {
          key: "currency",
          get: function () {
            return this._currency;
          }
        }]) && un(t.prototype, n), o && un(t, o), e;
      }();
      const sn = an;
      function cn(e) {
        return cn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, cn(e);
      }
      function fn(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      function ln(e, t) {
        return !t || "object" !== cn(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }
      function hn(e) {
        return hn = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, hn(e);
      }
      function pn(e, t) {
        return pn = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, pn(e, t);
      }
      var yn = function (e) {
        function t() {
          var e;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), (e = ln(this, hn(t).call(this, Z.T_BALANCE))).balance = new sn(), e;
        }
        var n, o, r;
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && pn(e, t);
        }(t, e), n = t, r = [{
          key: "fromData",
          value: function () {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : t.SAMPLE_DATA,
              n = new t();
            return n.balance = new sn(e.balance, e.currency), n;
          }
        }], (o = null) && fn(n.prototype, o), r && fn(n, r), t;
      }(Z);
      yn.SAMPLE_DATA = {
        balance: 0,
        currency: on.EUR
      };
      const _n = yn;
      function gn(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      const bn = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._amount = 0, this._endDate = 0, this._isActive = !1, this._isFreeAbo = !1, this._isPaidAbo = !0, this._isTrialAbo = !0, this._name = "";
        }
        var t, n, o;
        return t = e, (n = [{
          key: "amount",
          get: function () {
            return this._amount;
          },
          set: function (e) {
            this._amount = e;
          }
        }, {
          key: "endDate",
          get: function () {
            return this._endDate;
          },
          set: function (e) {
            this._endDate = e;
          }
        }, {
          key: "isActive",
          get: function () {
            return this._isActive;
          },
          set: function (e) {
            this._isActive = e;
          }
        }, {
          key: "isFreeAbo",
          get: function () {
            return this._isFreeAbo;
          },
          set: function (e) {
            this._isFreeAbo = e, this._isPaidAbo = !e;
          }
        }, {
          key: "isPaidAbo",
          get: function () {
            return this._isPaidAbo;
          },
          set: function (e) {
            this._isPaidAbo = e, this._isFreeAbo = !e;
          }
        }, {
          key: "isTrialAbo",
          get: function () {
            return this._isTrialAbo;
          },
          set: function (e) {
            this._isTrialAbo = e;
          }
        }, {
          key: "name",
          get: function () {
            return this._name;
          },
          set: function (e) {
            this._name = e;
          }
        }]) && gn(t.prototype, n), o && gn(t, o), e;
      }();
      function dn(e) {
        return dn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, dn(e);
      }
      function mn(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      function On(e, t) {
        return !t || "object" !== dn(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }
      function vn(e) {
        return vn = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, vn(e);
      }
      function wn(e, t) {
        return wn = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, wn(e, t);
      }
      var En = function (e) {
        function t() {
          var e;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), (e = On(this, vn(t).call(this, Z.T_ABOS))).abos = [], e;
        }
        var n, o, r;
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && wn(e, t);
        }(t, e), n = t, r = [{
          key: "fromData",
          value: function () {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : t.SAMPLE_DATA,
              n = new t();
            return Object.keys(e).forEach(function (t) {
              var o = new bn();
              o.amount = e[t].amount, o.endDate = e[t].endDate, o.isActive = e[t].isActive, o.isFreeAbo = e[t].isFreeAbo, o.isPaidAbo = e[t].isPaidAbo, o.isTrialAbo = e[t].isTrialAbo, o.name = e[t].name, n.add(o);
            }), n;
          }
        }], (o = [{
          key: "add",
          value: function (e) {
            this.abos.push(e);
          }
        }]) && mn(n.prototype, o), r && mn(n, r), t;
      }(Z);
      En.SAMPLE_DATA = {
        name: {
          amount: 0,
          endDate: {},
          isActive: !0,
          isFreeAbo: !1,
          isPaidAbo: !0,
          isTrialAbo: !0,
          name: "Abo"
        }
      };
      const Sn = En;
      function Tn(e) {
        return Tn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, Tn(e);
      }
      function kn(e, t) {
        return !t || "object" !== Tn(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }
      function An(e) {
        return An = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, An(e);
      }
      function Pn(e, t) {
        return Pn = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, Pn(e, t);
      }
      const In = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), kn(this, An(t).call(this, Z.T_LOGGED_OUT));
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && Pn(e, t);
        }(t, e), t;
      }(Z);
      function Nn(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var Cn = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }
        var t, n, o;
        return t = e, o = [{
          key: "fromJson",
          value: function () {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "{}",
              t = JSON.parse(e);
            if (!t.type) throw new TypeError("Invalid message format - no type field");
            switch (t.type) {
              case Z.T_COOKIE:
                return new oe(!!t.data);
              case Z.T_AVS:
                return new en(Qt.fromData(t.data));
              case Z.T_BALANCE:
                return _n.fromData(t.data);
              case Z.T_LOGGED_OUT:
                return new In();
              case Z.T_ABOS:
                return Sn.fromData(t.data);
              case Z.T_CONTENT:
                return new se();
              case Z.T_IFR_RDY:
                return new ct();
              case Z.T_HOOK:
                return rt.fromData(t.data);
              case Z.T_VIEW_RDY:
                return new yt();
              case Z.T_IFR_CLOSE:
                return new Tt(t.data);
              case Z.T_VISIBLE:
                return new Nt();
              case Z.T_SUCCESS:
                return new Ut(t.data);
              case Z.T_IS_LOGGED:
                return new Wt(t.data);
            }
            if (0 === t.type.indexOf(Z.TT_PREFIX)) {
              var n = t.type.substr(Z.TT_PREFIX.length);
              return new mt(n);
            }
            var o = new Z(t.type);
            return o.raw = e, o;
          }
        }], (n = null) && Nn(t.prototype, n), o && Nn(t, o), e;
      }();
      function Rn(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var Fn = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._onAny = [], this._onBeforeSend = [], this._onLoad = [];
        }
        var t, n, o;
        return t = e, n = [{
          key: "onLoad",
          value: function (e) {
            return this._onLoad.push(e), this;
          }
        }, {
          key: "onAny",
          value: function (e) {
            return this._onAny.push(e), this;
          }
        }, {
          key: "onBeforeSend",
          value: function (e) {
            return this._onBeforeSend.push(e), this;
          }
        }, {
          key: "trigger",
          value: function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
              n = "_" + e;
            if (void 0 === this[n]) throw new Error("Hook " + e + " not available!");
            return 0 === this[n].length || this[n].map(function (e) {
              e.apply(e, t);
            }), !0;
          }
        }], n && Rn(t.prototype, n), o && Rn(t, o), e;
      }();
      Fn.ON_LOAD = "onLoad", Fn.ON_ANY = "onAny", Fn.ON_BEFORE_SEND = "onBeforeSend";
      const Ln = Fn;
      function jn(e) {
        return jn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, jn(e);
      }
      function Vn(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }
      function Dn(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      function Mn(e, t) {
        return !t || "object" !== jn(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }
      function Un(e, t, n) {
        return Un = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (e, t, n) {
          var o = function (e, t) {
            for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = Gn(e)););
            return e;
          }(e, t);
          if (o) {
            var r = Object.getOwnPropertyDescriptor(o, t);
            return r.get ? r.get.call(n) : r.value;
          }
        }, Un(e, t, n || e);
      }
      function Gn(e) {
        return Gn = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, Gn(e);
      }
      function Hn(e, t) {
        return Hn = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, Hn(e, t);
      }
      var xn = function (e) {
        function t(e, n) {
          var o,
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t.NAME,
            i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : t.STYLE_DEFAULT;
          return Vn(this, t), (o = Mn(this, Gn(t).call(this, e, n, r, i)))._cookieMsg = null, o._frame.name = "vxpay-helper", o._hooks = new Ln(), o;
        }
        var n, o, r;
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && Hn(e, t);
        }(t, e), n = t, o = [{
          key: "_cookieMessageHandler",
          value: function (e, t, n) {
            n.origin && -1 === L.ORIGIN_VX.indexOf(n.origin) && t("Event origin does not match: " + n.origin);
            try {
              this._cookieMsg = Cn.fromJson(n.data);
            } catch (e) {
              this._cookieMsg = new oe();
            }
            this._hooks.trigger(Ln.ON_ANY, [this._cookieMsg], this._frame.id + "<VXPayHelperFrame>"), e(this._cookieMsg);
          }
        }, {
          key: "getLoginCookie",
          value: function () {
            var e = this;
            return new Promise(function (t, n) {
              if (null !== e._cookieMsg) return t(e._cookieMsg);
              w.addEvent(L.EVENT_MESSAGE, e._frame.ownerDocument.defaultView, e._cookieMessageHandler.bind(e, t, n));
            });
          }
        }, {
          key: "_markLoaded",
          value: function () {
            Un(Gn(t.prototype), "_markLoaded", this).call(this), this._hooks.trigger(Ln.ON_LOAD, [], this._frame.id + "<VXPayHelperFrame>");
          }
        }, {
          key: "message",
          value: function (e) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : L.ORIGIN_ALL;
            return this._hooks.trigger(Ln.ON_BEFORE_SEND, [e], this._frame.id + "<VXPayHelperFrame>"), Un(Gn(t.prototype), "message", this).call(this, e, n);
          }
        }, {
          key: "triggerLoad",
          value: function () {
            return !this._loaded && (this._frame.ownerDocument.getElementsByTagName("body").item(0).appendChild(this._frame), !0);
          }
        }, {
          key: "hooks",
          get: function () {
            return this._hooks;
          }
        }], o && Dn(n.prototype, o), r && Dn(n, r), t;
      }(L);
      xn.STYLE_DEFAULT = {
        display: "none"
      }, xn.NAME = "vx-helper-frame";
      const Bn = xn;
      function Xn(e) {
        return Xn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, Xn(e);
      }
      function Yn(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }
      function Wn(e, t) {
        return !t || "object" !== Xn(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }
      function Kn(e) {
        return Kn = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, Kn(e);
      }
      function Qn(e, t) {
        return Qn = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, Qn(e, t);
      }
      var zn = function (e) {
        function t() {
          var e,
            n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0;
          return Yn(this, t), (e = Wn(this, Kn(t).call(this, Z.T_SESSION))).token = n, e;
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && Qn(e, t);
        }(t, e), t;
      }(Z);
      const Jn = zn;
      function Zn(e) {
        return Zn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, Zn(e);
      }
      function qn(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }
      function $n(e, t) {
        return !t || "object" !== Zn(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }
      function eo(e) {
        return eo = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, eo(e);
      }
      function to(e, t) {
        return to = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, to(e, t);
      }
      var no = function (e) {
        function t() {
          var e,
            n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return qn(this, t), (e = $n(this, eo(t).call(this, Z.T_PARAMS))).options = n, e;
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && to(e, t);
        }(t, e), t;
      }(Z);
      function oo(e) {
        return oo = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, oo(e);
      }
      function ro(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }
      function io(e, t) {
        return !t || "object" !== oo(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }
      function uo(e) {
        return uo = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, uo(e);
      }
      function ao(e, t) {
        return ao = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, ao(e, t);
      }
      var so = function (e) {
        function t() {
          var e,
            n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
          return ro(this, t), e = io(this, uo(t).call(this, Z.T_ROUTE)), n.length > 0 && (e.route = n), e;
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && ao(e, t);
        }(t, e), t;
      }(Z);
      function co(e) {
        return co = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, co(e);
      }
      function fo(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }
      function lo(e, t) {
        return !t || "object" !== co(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }
      function ho(e) {
        return ho = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, ho(e);
      }
      function po(e, t) {
        return po = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, po(e, t);
      }
      var yo = function (e) {
        function t() {
          var e,
            n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return fo(this, t), (e = lo(this, ho(t).call(this, Z.T_INFO))).options = n, e;
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && po(e, t);
        }(t, e), t;
      }(Z);
      const _o = yo;
      function go(e) {
        return go = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, go(e);
      }
      function bo(e) {
        return function (e) {
          if (Array.isArray(e)) {
            for (var t = 0, n = new Array(e.length); t < e.length; t++) n[t] = e[t];
            return n;
          }
        }(e) || function (e) {
          if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
        }(e) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance");
        }();
      }
      function mo(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      function Oo(e, t) {
        return !t || "object" !== go(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }
      function vo(e) {
        return vo = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, vo(e);
      }
      function wo(e, t) {
        return wo = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, wo(e, t);
      }
      var Eo = function (e) {
        function t() {
          var e;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), (e = Oo(this, vo(t).call(this)))._onViewReady = [], e._onContentLoaded = [], e._onClose = [], e._onSuccess = [], e._onIframeReady = [], e._onLogin = [], e._onLogout = [], e._onFlowChange = [], e._onIsLoggedIn = [], e._onTransferToken = [], e._onAVSStatus = [], e._onBalance = [], e._onActiveAbos = [], e._onPayment = [], e._onSignup = [], e._onComfortSettingsChanged = [], e._onEmailVerified = [], e._onEmailNotVerified = [], e._onPasswordChanged = [], e._onShow = [], e;
        }
        var n, o, r;
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && wo(e, t);
        }(t, e), n = t, r = [{
          key: "getAvailable",
          value: function () {
            return [t.ON_VIEW_READY, t.ON_IFRAME_READY, t.ON_CONTENT_LOADED, t.ON_CLOSE, t.ON_SUCCESS, t.ON_LOGIN, t.ON_LOGOUT, t.ON_FLOW_CHANGE, t.ON_IS_LOGGED_IN, t.ON_TRANSFER_TOKEN, t.ON_AVS_STATUS, t.ON_BALANCE, t.ON_ACTIVE_ABOS, t.ON_PAYMENT, t.ON_SIGNUP, t.ON_COMFORT_SETTINGS_CHANGE, t.ON_EMAIL_VERIFIED, t.ON_EMAIL_NOT_VERIFIED, t.ON_PASSWORD_CHANGED, t.ON_SHOW];
          }
        }], (o = [{
          key: "onLogout",
          value: function (e) {
            return this._onLogout.push(e), this;
          }
        }, {
          key: "hasOnLogout",
          value: function (e) {
            return -1 !== this._onLogout.indexOf(e);
          }
        }, {
          key: "onActiveAbos",
          value: function (e) {
            return this._onActiveAbos.push(e), this;
          }
        }, {
          key: "hasOnActiveAbos",
          value: function (e) {
            return -1 !== this._onActiveAbos.indexOf(e);
          }
        }, {
          key: "onBalance",
          value: function (e) {
            return this._onBalance.push(e), this;
          }
        }, {
          key: "hasOnBalance",
          value: function (e) {
            return -1 !== this._onBalance.indexOf(e);
          }
        }, {
          key: "onAVSStatus",
          value: function (e) {
            this._onAVSStatus.push(e);
          }
        }, {
          key: "hasOnAVSStatus",
          value: function (e) {
            return -1 !== this._onAVSStatus.indexOf(e);
          }
        }, {
          key: "onIsLoggedIn",
          value: function (e) {
            return this._onIsLoggedIn.push(e), this;
          }
        }, {
          key: "hasOnIsLoggedIn",
          value: function (e) {
            return -1 !== this._onIsLoggedIn.indexOf(e);
          }
        }, {
          key: "onTransferToken",
          value: function (e) {
            return this._onTransferToken.push(e), this;
          }
        }, {
          key: "hasOnTransferToken",
          value: function (e) {
            return -1 !== this._onTransferToken.indexOf(e);
          }
        }, {
          key: "onFlowChange",
          value: function (e) {
            return this._onFlowChange.push(e), this;
          }
        }, {
          key: "onLogin",
          value: function (e) {
            return this._onLogin.push(e), this;
          }
        }, {
          key: "onIframeReady",
          value: function (e) {
            return this._onIframeReady.push(e), this;
          }
        }, {
          key: "onClose",
          value: function (e) {
            return this._onClose.push(e), this;
          }
        }, {
          key: "onSuccess",
          value: function (e) {
            return this._onSuccess.push(e), this;
          }
        }, {
          key: "onViewReady",
          value: function (e) {
            return this._onViewReady.push(e), this;
          }
        }, {
          key: "onContentLoaded",
          value: function (e) {
            return this._onContentLoaded.push(e), this;
          }
        }, {
          key: "onPayment",
          value: function (e) {
            return this._onPayment.push(e), this;
          }
        }, {
          key: "onSignup",
          value: function (e) {
            return this._onSignup.push(e), this;
          }
        }, {
          key: "onComfortSettingsChanged",
          value: function (e) {
            return this._onComfortSettingsChanged.push(e), this;
          }
        }, {
          key: "onShow",
          value: function (e) {
            return this._onShow.push(e), this;
          }
        }, {
          key: "onEmailVerified",
          value: function (e) {
            return this._onEmailVerified.push(e), this;
          }
        }, {
          key: "onEmailNotVerified",
          value: function (e) {
            return this._onEmailNotVerified.push(e), this;
          }
        }, {
          key: "onPasswordChanged",
          value: function (e) {
            return this._onPasswordChanged.push(e), this;
          }
        }, {
          key: "clone",
          value: function () {
            var e = new t();
            return e._onViewReady = bo(this._onViewReady), e._onContentLoaded = bo(this._onContentLoaded), e._onClose = bo(this._onClose), e._onSuccess = bo(this._onSuccess), e._onIframeReady = bo(this._onIframeReady), e._onLogin = bo(this._onLogin), e._onLogout = bo(this._onLogout), e._onFlowChange = bo(this._onFlowChange), e._onIsLoggedIn = bo(this._onIsLoggedIn), e._onTransferToken = bo(this._onTransferToken), e._onAVSStatus = bo(this._onAVSStatus), e._onBalance = bo(this._onBalance), e._onActiveAbos = bo(this._onActiveAbos), e._onPayment = bo(this._onPayment), e._onSignup = bo(this._onSignup), e._onComfortSettingsChanged = bo(this._onComfortSettingsChanged), e._onEmailVerified = bo(this._onEmailVerified), e._onEmailNotVerified = bo(this._onEmailNotVerified), e._onAny = bo(this._onAny), e._onBeforeSend = bo(this._onBeforeSend), e._onLoad = bo(this._onLoad), e._onShow = bo(this._onShow), e;
          }
        }]) && mo(n.prototype, o), r && mo(n, r), t;
      }(Ln);
      Eo.ON_VIEW_READY = "onViewReady", Eo.ON_IFRAME_READY = "onIframeReady", Eo.ON_CONTENT_LOADED = "onContentLoaded", Eo.ON_CLOSE = "onClose", Eo.ON_SHOW = "onShow", Eo.ON_SUCCESS = "onSuccess", Eo.ON_LOGIN = "onLogin", Eo.ON_LOGOUT = "onLogout", Eo.ON_FLOW_CHANGE = "onFlowChange", Eo.ON_IS_LOGGED_IN = "onIsLoggedIn", Eo.ON_TRANSFER_TOKEN = "onTransferToken", Eo.ON_AVS_STATUS = "onAVSStatus", Eo.ON_BALANCE = "onBalance", Eo.ON_ACTIVE_ABOS = "onActiveAbos", Eo.ON_PAYMENT = "onPayment", Eo.ON_SIGNUP = "onSignup", Eo.ON_COMFORT_SETTINGS_CHANGE = "onComfortSettingsChanged", Eo.ON_EMAIL_VERIFIED = "onEmailVerified", Eo.ON_EMAIL_NOT_VERIFIED = "onEmailNotVerified", Eo.ON_PASSWORD_CHANGED = "onPasswordChanged";
      const So = Eo;
      var To = {
        MICROPHONE: "microphone",
        CAMERA: "camera",
        getDefaults: function () {
          return [To.CAMERA, To.MICROPHONE];
        }
      };
      const ko = To;
      function Ao(e) {
        return Ao = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, Ao(e);
      }
      function Po(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }
      function Io(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      function No(e, t) {
        return !t || "object" !== Ao(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }
      function Co(e, t, n) {
        return Co = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (e, t, n) {
          var o = function (e, t) {
            for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = Ro(e)););
            return e;
          }(e, t);
          if (o) {
            var r = Object.getOwnPropertyDescriptor(o, t);
            return r.get ? r.get.call(n) : r.value;
          }
        }, Co(e, t, n || e);
      }
      function Ro(e) {
        return Ro = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, Ro(e);
      }
      function Fo(e, t) {
        return Fo = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, Fo(e, t);
      }
      var Lo = function (e) {
        function t(e, n) {
          var o,
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t.NAME,
            i = arguments.length > 3 ? arguments[3] : void 0,
            u = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {};
          return Po(this, t), u = Object.assign({}, t.getDefaultStyles(e), u), (o = No(this, Ro(t).call(this, e, n, r, u)))._frame.allowTransparency = !0, o._frame.allow = ko.getDefaults().join(";"), o._frame.allowfullscreen = "", o._frame.name = "vxpay", o._sessionInitialized = !1, o._hooks = i, o;
        }
        var n, o, r;
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && Fo(e, t);
        }(t, e), n = t, o = [{
          key: "triggerLoad",
          value: function () {
            this._loaded || this._frame.ownerDocument.getElementsByTagName("body").item(0).appendChild(this._frame);
          }
        }, {
          key: "removeFromDOM",
          value: function () {
            this._frame.remove();
          }
        }, {
          key: "_markLoaded",
          value: function () {
            return Co(Ro(t.prototype), "_markLoaded", this).call(this), this._hooks.trigger(So.ON_LOAD, [], this._frame.id);
          }
        }, {
          key: "message",
          value: function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : L.ORIGIN_ALL;
            return this._hooks.trigger(So.ON_BEFORE_SEND, [e], this._frame.id), null !== this._frame.contentWindow && this._frame.contentWindow.postMessage(e.toString(), t), this;
          }
        }, {
          key: "initSession",
          value: function () {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0;
            return this._sessionInitialized || (e = e || null, this.message(new Jn(e)), this._sessionInitialized = !0), this;
          }
        }, {
          key: "sendOptions",
          value: function () {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return this.message(new no(e));
          }
        }, {
          key: "sendAdditionalOptions",
          value: function () {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return this.message(new _o(e));
          }
        }, {
          key: "sendUpdateParams",
          value: function (e) {
            return this.message(new no(e));
          }
        }, {
          key: "changeRoute",
          value: function () {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
            return this.message(new so(e));
          }
        }, {
          key: "setVisible",
          value: function () {
            return this.message(new Nt());
          }
        }, {
          key: "show",
          value: function () {
            Co(Ro(t.prototype), "show", this).call(this), this._hooks.trigger(So.ON_SHOW, [], this._frame.id);
          }
        }], r = [{
          key: "getDefaultStyles",
          value: function () {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0,
              t = void 0 !== e ? e.defaultView.navigator.userAgent : "",
              n = new U(t),
              o = void 0 !== e ? e.getElementsByTagName("body").item(0) : null,
              r = {
                border: "none",
                width: "100%",
                height: "100%",
                top: "0",
                left: "0",
                display: "none",
                zIndex: "9999"
              };
            return r.position = n.isMobile() ? L.POSITION_ABSOLUTE : L.POSITION_FIXED, void 0 !== e && T.isStyleAttributeSuppored(o, "maxHeight", "100vh") ? r.maxHeight = "100vh" : n.isMobile() && (r.maxHeight = T.getClientHeight(e.defaultView) + "px"), r;
          }
        }], o && Io(n.prototype, o), r && Io(n, r), t;
      }(L);
      Lo.NAME = "vx-payment-frame";
      const jo = Lo;
      const Vo = function () {
        var e, t;
        return {
          promise: new Promise(function (n, o) {
            e = n, t = o;
          }),
          resolve: e,
          reject: t
        };
      };
      function Do(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var Mo = function () {
        function e(t, n, o, r) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._document = t, this._loaded = !1, this._name = n, this._config = o, this._hooks = r, this._route = e.DEFAULT_ROUTE, this._window = null, this._deferred = Vo(), this._invisibleFrame = new jo(t, o.getPaymentFrameUrl(), jo.NAME + "_hidden", r), this._invisibleFrame.triggerLoad();
        }
        var t, n, o;
        return t = e, n = [{
          key: "triggerLoad",
          value: function () {
            return this.getNewTab(!0), this._deferred.promise;
          }
        }, {
          key: "getNewTab",
          value: function () {
            var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            if (e) {
              var t = this._config.getPaymentFrameUrl() + "#" + this._route;
              this._window = this._document.defaultView.open(t, this._name), this._deferred.resolve();
            }
          }
        }, {
          key: "sendOptions",
          value: function () {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return this._config.merge(e), this.message(new no(e)), this;
          }
        }, {
          key: "sendAdditionalOptions",
          value: function () {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return this._config.merge(e), this.message(new _o(e)), this;
          }
        }, {
          key: "sendUpdateParams",
          value: function (e) {
            return this.message(new no(e)), this;
          }
        }, {
          key: "message",
          value: function (e) {
            var t = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : L.ORIGIN_ALL;
            return e.isAction ? this._invisibleFrame.message(e, n) : this._deferred.promise.then(function () {
              t._hooks.trigger(So.ON_BEFORE_SEND, [e], t._name), t._window.postMessage(e.toString(), n);
            }), this;
          }
        }, {
          key: "initSession",
          value: function () {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0;
            return this.message(new Jn(e)), this;
          }
        }, {
          key: "changeRoute",
          value: function () {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : e.DEFAULT_ROUTE;
            return this._route = t, this.message(new so(t));
          }
        }, {
          key: "setVisible",
          value: function () {}
        }, {
          key: "show",
          value: function () {
            return this;
          }
        }, {
          key: "hide",
          value: function () {
            return this._window && !this._window.closed && (this._window.close(), this.resetWindow()), this._loaded = !1, this._route = e.DEFAULT_ROUTE, this._deferred = Vo(), this;
          }
        }, {
          key: "resetWindow",
          value: function () {
            this._window = null;
          }
        }, {
          key: "document",
          get: function () {
            return this._document;
          }
        }, {
          key: "name",
          get: function () {
            return this._name;
          }
        }, {
          key: "config",
          get: function () {
            return this._config;
          }
        }, {
          key: "loaded",
          get: function () {
            return this._loaded;
          }
        }, {
          key: "route",
          get: function () {
            return this._route;
          }
        }, {
          key: "url",
          set: function (e) {
            this._window ? this.getNewTab(!0) : this.getNewTab(!1);
          }
        }], n && Do(t.prototype, n), o && Do(t, o), e;
      }();
      Mo.NAME = "vx-payment-tab", Mo.DEFAULT_ROUTE = "/";
      const Uo = Mo;
      function Go(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var Ho = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }
        var t, n, o;
        return t = e, o = [{
          key: "init",
          value: function (e, t) {
            return void 0 !== e.helperFrame || (e.helperFrame = new Bn(e.window.document, L.ORIGIN_VX + "/VXPAY-V" + e.apiVersion + "/helper"), e.config.logging && e.helperFrame.hooks.onAny(function (t) {
              return e.logger.log(K.IN, t);
            }).onBeforeSend(function (t) {
              return e.logger.log(K.OUT, t);
            }), e.helperFrame.triggerLoad()), t(e);
          }
        }], (n = null) && Go(t.prototype, n), o && Go(t, o), e;
      }();
      const xo = function (e, t, n) {
        try {
          return e._hooks.hasOnAVSStatus(t) || e._hooks.onAVSStatus(t), e;
        } catch (e) {
          n(e);
        }
      };
      function Bo(e) {
        return Bo = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, Bo(e);
      }
      function Xo(e, t) {
        return !t || "object" !== Bo(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }
      function Yo(e) {
        return Yo = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, Yo(e);
      }
      function Wo(e, t) {
        return Wo = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, Wo(e, t);
      }
      var Ko = function (e) {
        function t() {
          var e;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), (e = Xo(this, Yo(t).call(this, Z.TA_AVS))).isAction = !0, e;
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && Wo(e, t);
        }(t, e), t;
      }(Z);
      const Qo = function (e) {
        return e._paymentFrame.message(new Ko()), e;
      };
      const zo = function (e, t, n) {
        try {
          return e._hooks.hasOnBalance(t) || e._hooks.onBalance(t), e;
        } catch (e) {
          n(e);
        }
      };
      function Jo(e) {
        return Jo = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, Jo(e);
      }
      function Zo(e, t) {
        return !t || "object" !== Jo(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }
      function qo(e) {
        return qo = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, qo(e);
      }
      function $o(e, t) {
        return $o = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, $o(e, t);
      }
      const er = function (e) {
        function t() {
          var e;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), (e = Zo(this, qo(t).call(this, Z.TA_BALANCE))).isAction = !0, e;
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && $o(e, t);
        }(t, e), t;
      }(Z);
      const tr = function (e) {
        return e._paymentFrame.message(new er()), e;
      };
      const nr = function (e, t, n) {
        try {
          e._hooks.hasOnActiveAbos(t) || e._hooks.onActiveAbos(t);
        } catch (e) {
          n(e);
        }
        return e;
      };
      function or(e) {
        return or = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, or(e);
      }
      function rr(e, t) {
        return !t || "object" !== or(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }
      function ir(e) {
        return ir = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, ir(e);
      }
      function ur(e, t) {
        return ur = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, ur(e, t);
      }
      const ar = function (e) {
        function t() {
          var e;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), (e = rr(this, ir(t).call(this, Z.TA_ABOS))).isAction = !0, e;
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && ur(e, t);
        }(t, e), t;
      }(Z);
      const sr = function (e) {
        return e._paymentFrame.message(new ar()), e;
      };
      const cr = function (e, t, n) {
        try {
          return e._hooks.hasOnLogout(t) || e._hooks.onLogout(t), e;
        } catch (e) {
          n(e);
        }
      };
      function fr(e) {
        return fr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, fr(e);
      }
      function lr(e, t) {
        return !t || "object" !== fr(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }
      function hr(e) {
        return hr = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, hr(e);
      }
      function pr(e, t) {
        return pr = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, pr(e, t);
      }
      const yr = function (e) {
        function t() {
          var e;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), (e = lr(this, hr(t).call(this, Z.TA_LOGOUT))).isAction = !0, e;
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && pr(e, t);
        }(t, e), t;
      }(Z);
      var _r = null,
        gr = function () {
          return _r._paymentFrame.message(new yr());
        };
      const br = function (e) {
        return _r = e, e.state.hasToken ? e._paymentFrame.message(new yr()) : e._hooks.hasOnTransferToken(gr) || e._hooks.onTransferToken(gr), e;
      };
      function dr(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var mr = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this.reset();
        }
        var t, n, o;
        return t = e, (n = [{
          key: "markFrameReady",
          value: function () {
            this._isFrameReady = !0, this._isFrameInProgress = !1;
          }
        }, {
          key: "markContentLoaded",
          value: function () {
            this._isContentLoaded = !0;
          }
        }, {
          key: "markHasToken",
          value: function (e) {
            this._token = e;
          }
        }, {
          key: "markSessionInitialized",
          value: function () {
            this._isSessionInitialized = !0;
          }
        }, {
          key: "markIsFrameOpen",
          value: function () {
            this._isFrameOpen = !0;
          }
        }, {
          key: "markIsFrameClose",
          value: function () {
            this._isFrameOpen = !1;
          }
        }, {
          key: "reset",
          value: function () {
            this._isFrameReady = !1, this._token = void 0, this._isContentLoaded = !1, this._isSessionInitialized = !1, this._isFrameInProgress = !1, this._isFrameOpen = !1;
          }
        }, {
          key: "isFrameInProgress",
          get: function () {
            return this._isFrameInProgress;
          },
          set: function (e) {
            this._isFrameInProgress = e;
          }
        }, {
          key: "isFrameReady",
          get: function () {
            return this._isFrameReady;
          },
          set: function (e) {
            this._isFrameReady = e;
          }
        }, {
          key: "hasToken",
          get: function () {
            return void 0 !== this._token;
          }
        }, {
          key: "isContentLoaded",
          get: function () {
            return this._isContentLoaded;
          },
          set: function (e) {
            this._isContentLoaded = e;
          }
        }, {
          key: "isSessionInitialized",
          get: function () {
            return this._isSessionInitialized;
          },
          set: function (e) {
            this._isSessionInitialized = e;
          }
        }, {
          key: "transferToken",
          get: function () {
            return this._token;
          }
        }, {
          key: "isFrameOpen",
          get: function () {
            return this._isFrameOpen;
          }
        }]) && dr(t.prototype, n), o && dr(t, o), e;
      }();
      function Or(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var vr = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }
        var t, n, o;
        return t = e, o = [{
          key: "getAllowed",
          value: function () {
            return [e.LOGIN, e.SIGN_UP, e.PAYMENT, e.ABO, e.ABO_OVERVIEW, e.AVS, e.PROMOCODE, e.OP_COMP, e.PASS, e.PASS_RESET, e.RECHARGE, e.ONE_CLICK, e.SETTINGS, e.VOICE_CALL, e.LIMIT, e.MIGRATION, e.TELEGRAM];
          }
        }], (n = null) && Or(t.prototype, n), o && Or(t, o), e;
      }();
      vr.LOGIN = "/login", vr.SIGN_UP = "/signup", vr.PAYMENT = "/payment", vr.ABO = "/abo", vr.AVS = "/avs", vr.PROMOCODE = "/promocode", vr.OP_COMP = "/opcompensation", vr.PASS = "/password", vr.PASS_RESET = "/passwordreset", vr.RECHARGE = "/autorecharge", vr.ONE_CLICK = "/comfort", vr.SETTINGS = "/user/settings", vr.VOICE_CALL = "/voicecall", vr.LIMIT = "/limit", vr.MIGRATION = "/migration", vr.ABO_OVERVIEW = "/abooverview", vr.TELEGRAM = "/telegram";
      const wr = vr;
      function Er(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var Sr = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }
        var t, n, o;
        return t = e, o = [{
          key: "defaultFlowOptions",
          value: function () {
            return {
              flow: f.LOGIN
            };
          }
        }, {
          key: "open",
          value: function (t) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return t.logger.log("VXPayLogin::open()"), t.paymentFrame.then(function (o) {
              return o.sendOptions(Object.assign({}, e.defaultFlowOptions(), n)).sendAdditionalOptions(t.config.getAdditionalOptions()).changeRoute(wr.LOGIN).initSession();
            }), t.config.route = wr.LOGIN, t;
          }
        }], (n = null) && Er(t.prototype, n), o && Er(t, o), e;
      }();
      function Tr(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var kr = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }
        var t, n, o;
        return t = e, o = [{
          key: "defaultFlowOptions",
          value: function () {
            return {
              flow: f.SIGNUP
            };
          }
        }, {
          key: "open",
          value: function (t) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return t.logger.log("VXPaySignUp::open()"), t.paymentFrame.then(function (o) {
              return o.sendUpdateParams(Object.assign({}, e.defaultFlowOptions(), n)).sendAdditionalOptions(t.config.getAdditionalOptions()).changeRoute(wr.SIGN_UP).initSession();
            }), t.config.route = wr.SIGN_UP, t;
          }
        }], (n = null) && Tr(t.prototype, n), o && Tr(t, o), e;
      }();
      var Ar = function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e);
      };
      Ar.VOICE_CALL = "Voice", Ar.CREDIT_CARD = "CC", Ar.LASTSCHRIFT = "LS";
      const Pr = Ar;
      function Ir(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      const Nr = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }
        var t, n, o;
        return t = e, o = [{
          key: "defaultFlowOptions",
          value: function () {
            return {
              flow: f.CHARGE,
              paytype: Pr.VOICE_CALL
            };
          }
        }, {
          key: "open",
          value: function (t) {
            return t.logger.log("VXPayVoiceCall::reset()"), t.paymentFrame.then(function (n) {
              return n.sendOptions(e.defaultFlowOptions()).sendAdditionalOptions(t.config.getAdditionalOptions()).changeRoute(wr.VOICE_CALL).initSession();
            }), t.config.route = wr.VOICE_CALL, t;
          }
        }], (n = null) && Ir(t.prototype, n), o && Ir(t, o), e;
      }();
      function Cr(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var Rr = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }
        var t, n, o;
        return t = e, o = [{
          key: "defaultFlowOptions",
          value: function () {
            return {
              flow: f.CHARGE,
              paytype: ""
            };
          }
        }, {
          key: "open",
          value: function (t) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return t.logger.log("VXPayPayment()"), t.paymentFrame.then(function (o) {
              return o.sendOptions(Object.assign({}, e.defaultFlowOptions(), n)).sendAdditionalOptions(t.config.getAdditionalOptions()).changeRoute(wr.PAYMENT).initSession();
            }), t.config.route = wr.PAYMENT, t;
          }
        }], (n = null) && Cr(t.prototype, n), o && Cr(t, o), e;
      }();
      const Fr = Rr;
      function Lr(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      const jr = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }
        var t, n, o;
        return t = e, o = [{
          key: "defaultFlowOptions",
          value: function () {
            return {
              flow: f.SETTINGS,
              paytype: ""
            };
          }
        }, {
          key: "open",
          value: function (t) {
            return t.logger.log("VXPaySettings()"), t.paymentFrame.then(function (n) {
              return n.sendOptions(e.defaultFlowOptions()).sendAdditionalOptions(t.config.getAdditionalOptions()).changeRoute(wr.SETTINGS).initSession();
            }), t.config.route = wr.SETTINGS, t;
          }
        }], (n = null) && Lr(t.prototype, n), o && Lr(t, o), e;
      }();
      function Vr(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var Dr = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }
        var t, n, o;
        return t = e, o = [{
          key: "defaultFlowOptions",
          value: function () {
            return {
              flow: f.VIP_ABO
            };
          }
        }, {
          key: "open",
          value: function (t) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return t.logger.log("VXPayAbo::open()"), t.paymentFrame.then(function (o) {
              return o.sendOptions(Object.assign({}, e.defaultFlowOptions(), n)).sendAdditionalOptions(t.config.getAdditionalOptions()).changeRoute(wr.ABO).initSession();
            }), t.config.route = wr.ABO, t;
          }
        }], (n = null) && Vr(t.prototype, n), o && Vr(t, o), e;
      }();
      function Mr(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var Ur = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }
        var t, n, o;
        return t = e, o = [{
          key: "defaultFlowOptions",
          value: function (e) {
            var t = new b(e.window.URL);
            return {
              flow: f.PASSWORD_RESET,
              pwdresetUserId: t.getQueryParam("u", e.window.location.href),
              pwdresetUserName: t.getQueryParam("tpLoginPwdLost", e.window.location.href),
              pwdresetKey: t.getQueryParam("key", e.window.location.href)
            };
          }
        }, {
          key: "run",
          value: function (t) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            t.logger.log("VXPayResetPassword()");
            var o = Object.assign({}, e.defaultFlowOptions(t.config), n);
            return t.paymentFrame.then(function (e) {
              return e.initSession().sendOptions(o).sendAdditionalOptions(t.config.getAdditionalOptions()).changeRoute(wr.PASS_RESET);
            }), t.config.route = wr.PASS_RESET, t;
          }
        }], (n = null) && Mr(t.prototype, n), o && Mr(t, o), e;
      }();
      function Gr(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var Hr = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }
        var t, n, o;
        return t = e, o = [{
          key: "defaultFlowOptions",
          value: function (e) {
            var t = new b(e.window.URL);
            return {
              flow: f.PASSWORD_LOST,
              pwdresetUserId: t.getQueryParam("u", e.window.location.href),
              pwdresetUserName: t.getQueryParam("tpLoginPwdLost", e.window.location.href),
              pwdresetEmail: t.getQueryParam("tpEmailPwdLost", e.window.location.href)
            };
          }
        }, {
          key: "run",
          value: function (t) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            t.logger.log("VXPayLostPassword()");
            var o = Object.assign({}, e.defaultFlowOptions(t.config), n);
            return t.paymentFrame.then(function (e) {
              return e.initSession().sendOptions(o).sendAdditionalOptions(t.config.getAdditionalOptions()).changeRoute(wr.PASS);
            }), t.config.route = wr.PASS, t;
          }
        }], (n = null) && Gr(t.prototype, n), o && Gr(t, o), e;
      }();
      function xr(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      const Br = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }
        var t, n, o;
        return t = e, o = [{
          key: "defaultFlowOptions",
          value: function () {
            return {
              flow: f.LIMIT,
              paytype: ""
            };
          }
        }, {
          key: "open",
          value: function (t) {
            return t.logger.log("VXPayLimitedPayment()"), t.paymentFrame.then(function (n) {
              return n.sendOptions(e.defaultFlowOptions()).sendAdditionalOptions(t.config.getAdditionalOptions()).changeRoute(wr.LIMIT).initSession();
            }), t.config.route = wr.LIMIT, t;
          }
        }], (n = null) && xr(t.prototype, n), o && xr(t, o), e;
      }();
      function Xr(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var Yr = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }
        var t, n, o;
        return t = e, o = [{
          key: "defaultFlowOptions",
          value: function () {
            return {
              flow: f.TRIAL_VIP_ABO
            };
          }
        }, {
          key: "open",
          value: function (t) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return t.logger.log("VXPayVipAboTrial()"), t.paymentFrame.then(function (o) {
              return o.initSession().sendOptions(Object.assign({}, e.defaultFlowOptions(), n)).sendAdditionalOptions(t.config.getAdditionalOptions()).changeRoute(wr.ABO);
            }), t.config.route = wr.ABO, t;
          }
        }], (n = null) && Xr(t.prototype, n), o && Xr(t, o), e;
      }();
      function Wr(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var Kr = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }
        var t, n, o;
        return t = e, o = [{
          key: "defaultFlowOptions",
          value: function () {
            return {
              flow: f.VXTV_ABO
            };
          }
        }, {
          key: "open",
          value: function (t) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return t.logger.log("VXPayOpenPaymentCommand()"), t.paymentFrame.then(function (o) {
              return o.initSession().sendOptions(Object.assign({}, e.defaultFlowOptions(), n)).sendAdditionalOptions(t.config.getAdditionalOptions()).changeRoute(wr.ABO);
            }), t.config.route = wr.ABO, t;
          }
        }], (n = null) && Wr(t.prototype, n), o && Wr(t, o), e;
      }();
      function Qr(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var zr = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }
        var t, n, o;
        return t = e, o = [{
          key: "defaultFlowOptions",
          value: function () {
            return {
              flow: f.AVS
            };
          }
        }, {
          key: "open",
          value: function (t) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return t.logger.log("VXPayAVS()"), t.paymentFrame.then(function (o) {
              return o.initSession().sendOptions(Object.assign({}, e.defaultFlowOptions(), n)).sendAdditionalOptions(t.config.getAdditionalOptions()).changeRoute(wr.AVS);
            }), t.config.route = wr.AVS, t;
          }
        }], (n = null) && Qr(t.prototype, n), o && Qr(t, o), e;
      }();
      function Jr(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var Zr = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }
        var t, n, o;
        return t = e, o = [{
          key: "defaultFlowOptions",
          value: function () {
            return {
              flow: f.PROMOCODE
            };
          }
        }, {
          key: "open",
          value: function (t, n) {
            return t.logger.log("VXPayPromoCode()"), t.paymentFrame.then(function (o) {
              return o.initSession().sendOptions(Object.assign({}, e.defaultFlowOptions(), n)).sendAdditionalOptions(t.config.getAdditionalOptions()).changeRoute(wr.PROMOCODE);
            }), t.config.route = wr.PROMOCODE, t;
          }
        }], (n = null) && Jr(t.prototype, n), o && Jr(t, o), e;
      }();
      function qr(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var $r = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }
        var t, n, o;
        return t = e, o = [{
          key: "defaultFlowOptions",
          value: function () {
            return {
              flow: f.ONE_CLICK,
              paytype: "",
              oneClickData: {
                data: null
              }
            };
          }
        }, {
          key: "run",
          value: function (t) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return t.logger.log("VXPayOneClick()"), t.paymentFrame.then(function (o) {
              return o.initSession().sendOptions(Object.assign({}, e.defaultFlowOptions(), n)).sendAdditionalOptions(t.config.getAdditionalOptions()).changeRoute(wr.ONE_CLICK);
            }), t.config.route = wr.ONE_CLICK, t;
          }
        }], (n = null) && qr(t.prototype, n), o && qr(t, o), e;
      }();
      const ei = $r;
      function ti(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var ni = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }
        var t, n, o;
        return t = e, o = [{
          key: "defaultFlowOptions",
          value: function () {
            return {
              flow: f.AUTO_RECHARGE,
              autoRechargeData: {
                data: null
              }
            };
          }
        }, {
          key: "run",
          value: function (t) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return t.logger.log("VXPayAutoRecharge()"), t.paymentFrame.then(function (o) {
              return o.initSession().sendOptions(Object.assign({}, e.defaultFlowOptions(), n)).sendAdditionalOptions(t.config.getAdditionalOptions()).changeRoute(wr.RECHARGE);
            }), t.config.route = wr.RECHARGE, t;
          }
        }], (n = null) && ti(t.prototype, n), o && ti(t, o), e;
      }();
      const oi = ni;
      function ri(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var ii = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }
        var t, n, o;
        return t = e, o = [{
          key: "defaultFlowOptions",
          value: function () {
            return {
              flow: f.OP_COMPENSATION
            };
          }
        }, {
          key: "open",
          value: function (t) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return t.logger.log("VXPayOpenBalance()"), t.paymentFrame.then(function (o) {
              return o.initSession().sendOptions(Object.assign({}, e.defaultFlowOptions(), n)).sendAdditionalOptions(t.config.getAdditionalOptions()).changeRoute(wr.OP_COMP);
            }), t.config.route = wr.OP_COMP, t;
          }
        }], (n = null) && ri(t.prototype, n), o && ri(t, o), e;
      }();
      function ui(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var ai = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }
        var t, n, o;
        return t = e, o = [{
          key: "defaultFlowOptions",
          value: function () {
            return {
              flow: f.MIGRATION
            };
          }
        }, {
          key: "open",
          value: function (t) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return t.logger.log("VXPayMigration::open()"), t.paymentFrame.then(function (o) {
              return o.sendUpdateParams(Object.assign({}, e.defaultFlowOptions(), n)).sendAdditionalOptions(t.config.getAdditionalOptions()).changeRoute(wr.MIGRATION).initSession();
            }), t.config.route = wr.MIGRATION, t;
          }
        }], (n = null) && ui(t.prototype, n), o && ui(t, o), e;
      }();
      function si(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var ci = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }
        var t, n, o;
        return t = e, o = [{
          key: "defaultFlowOptions",
          value: function () {
            return {
              flow: f.TELEGRAM
            };
          }
        }, {
          key: "open",
          value: function (t) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return t.logger.log("VXPayTelegram::open()"), t.paymentFrame.then(function (o) {
              return o.sendUpdateParams(Object.assign({}, e.defaultFlowOptions(), n)).sendAdditionalOptions(t.config.getAdditionalOptions()).changeRoute(wr.TELEGRAM).initSession();
            }), t.config.route = wr.TELEGRAM, t;
          }
        }], (n = null) && si(t.prototype, n), o && si(t, o), e;
      }();
      function fi(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var li = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }
        var t, n, o;
        return t = e, o = [{
          key: "trigger",
          value: function (e) {
            return e.logger.log("VXPayShowForTab::trigger()"), e.config.enableTab && e._paymentFrame.triggerLoad(), e;
          }
        }], (n = null) && fi(t.prototype, n), o && fi(t, o), e;
      }();
      const hi = function (e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0;
        if (t.origin && -1 === L.ORIGIN_VX.indexOf(t.origin)) return !1;
        var o = Cn.fromJson(t.data);
        switch (e.trigger(So.ON_ANY, [o], n), o.type) {
          case Z.T_TOKEN:
            return e.trigger(So.ON_TRANSFER_TOKEN, [o], n);
          case Z.T_AVS:
            return e.trigger(So.ON_AVS_STATUS, [o], n);
          case Z.T_BALANCE:
            return e.trigger(So.ON_BALANCE, [o], n);
          case Z.T_ABOS:
            return e.trigger(So.ON_ACTIVE_ABOS, [o], n);
          case Z.T_IFR_RDY:
            return e.trigger(So.ON_IFRAME_READY, [o], n);
          case Z.T_CONTENT:
            return e.trigger(So.ON_CONTENT_LOADED, [o], n);
          case Z.T_VIEW_RDY:
            return e.trigger(So.ON_VIEW_READY, [o], n);
          case Z.T_IFR_CLOSE:
            return e.trigger(So.ON_CLOSE, [o], n);
          case Z.T_SUCCESS:
            return e.trigger(So.ON_SUCCESS, [o], n);
          case Z.T_IS_LOGGED:
            return e.trigger(So.ON_IS_LOGGED_IN, [o], n);
          case Z.T_LOGGED_OUT:
            return e.trigger(So.ON_LOGOUT, [o], n);
          case Z.T_HOOK:
            switch (o.hook) {
              case _e.H_LOGIN:
                return e.trigger(So.ON_LOGIN, [o], n);
              case _e.H_FLOW:
                return e.trigger(So.ON_FLOW_CHANGE, [o], n);
              case _e.H_PAYMENT:
                return e.trigger(So.ON_PAYMENT, [o], n);
              case _e.H_SIGNUP:
                return e.trigger(So.ON_SIGNUP, [o], n);
              case _e.H_C_SETTINGS:
                return e.trigger(So.ON_COMFORT_SETTINGS_CHANGE, [o], n);
              case _e.H_E_VERIFIED:
                return e.trigger(So.ON_EMAIL_VERIFIED, [o], n);
              case _e.H_E_NOT_VERIFIED:
                return e.trigger(So.ON_EMAIL_NOT_VERIFIED, [o], n);
              case _e.H_PASS:
                return e.trigger(So.ON_PASSWORD_CHANGED, [o], n);
            }
        }
      };
      function pi(e) {
        return pi = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, pi(e);
      }
      function yi(e, t) {
        return !t || "object" !== pi(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }
      function _i(e) {
        return _i = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, _i(e);
      }
      function gi(e, t) {
        return gi = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, gi(e, t);
      }
      var bi = function (e) {
        function t() {
          var e;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), (e = yi(this, _i(t).call(this, Z.TA_IS_LOGGED))).isAction = !0, e;
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && gi(e, t);
        }(t, e), t;
      }(Z);
      const di = function (e, t, n) {
        e.logger.log("VXPayIsLoggedInTrigger()");
        try {
          e._hooks.hasOnIsLoggedIn(t) || e._hooks.onIsLoggedIn(t), e._paymentFrame.message(new bi());
        } catch (e) {
          n(e);
        }
        return e;
      };
      function mi(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      const Oi = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }
        var t, n, o;
        return t = e, o = [{
          key: "reset",
          value: function (e) {
            return e.logger.log("VXPayTokenForTab()"), e.config.enableTab && e.state.markHasToken(void 0), e;
          }
        }], (n = null) && mi(t.prototype, n), o && mi(t, o), e;
      }();
      function vi(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var wi = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }
        var t, n, o;
        return t = e, o = [{
          key: "tokenTransferred",
          value: function (e) {
            return e.logger.log("VXPayWhen::tokenTransferred()"), new Promise(function (t, n) {
              try {
                e.state.hasToken ? t(e) : e._hooks.onTransferToken(function () {
                  return t(e);
                });
              } catch (e) {
                n(e);
              }
            });
          }
        }], (n = null) && vi(t.prototype, n), o && vi(t, o), e;
      }();
      function Ei(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var Si = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }
        var t, n, o;
        return t = e, o = [{
          key: "init",
          value: function (e, t) {
            var n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
            if (e.logger.log("VXPayInitPaymentMiddleware()", n), e.state.isContentLoaded) {
              if (e.logger.log("VXPayInitPaymentMiddleware() - already loaded, resolve ..."), !e._paymentFrame || !e._paymentFrame.url || e._paymentFrame.url.substr(e._paymentFrame.url.indexOf("lang=") + 5, 2) === e.config._language) return t(e);
              e._reloadByConfig(t);
            }
            if (e.state.isFrameInProgress && !n) return e.logger.log("VXPayInitPaymentMiddleware() - already in progress, resolve ..."), t(e);
            e.state.isFrameInProgress = n, e.config.enableTab ? e._paymentFrame = new Uo(e.window.document, Uo.NAME, e.config, e._hooks) : e._paymentFrame = void 0 === e._paymentFrame ? new jo(e.window.document, e.config.getPaymentFrameUrl(), jo.NAME, e._hooks) : e._paymentFrame, e._paymentFrame.loaded || (e.config.logging && e._hooks.onAny(function (t) {
              return e.logger.log(K.IN, t);
            }).onBeforeSend(function (t) {
              return e.logger.log(K.OUT, t);
            }), e._hooks.onIframeReady(e.state.markFrameReady.bind(e.state)).onShow(e.state.markIsFrameOpen.bind(e.state)).onContentLoaded(e.state.markContentLoaded.bind(e.state)).onTransferToken(e.state.markHasToken.bind(e.state)).onTransferToken(e.config.setTokenFromMessage.bind(e.config)).onFlowChange(e.config.updateFlow.bind(e.config)).onViewReady(e._paymentFrame.setVisible.bind(e._paymentFrame)).onViewReady(e._paymentFrame.show.bind(e._paymentFrame)).onSuccess(e._paymentFrame.hide.bind(e._paymentFrame)).onSuccess(e.state.reset).onSuccess(e.state.markIsFrameClose.bind(e.state)).onClose(e._paymentFrame.hide.bind(e._paymentFrame)).onClose(e.state.reset).onClose(e.state.markIsFrameClose.bind(e.state)).onContentLoaded(function () {
              return t(e);
            }), e.startListening(), n && !e.config.enableTab ? (e.logger.log("VXPayInitPaymentMiddleware() - not loaded yet, trigger load"), e._paymentFrame.url = e.config.getPaymentFrameUrl(), e._paymentFrame.triggerLoad()) : t(e));
          }
        }], (n = null) && Ei(t.prototype, n), o && Ei(t, o), e;
      }();
      function Ti(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var ki = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }
        var t, n, o;
        return t = e, o = [{
          key: "defaultFlowOptions",
          value: function () {
            return {
              flow: f.ABO_OVERVIEW
            };
          }
        }, {
          key: "open",
          value: function (t) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return t.logger.log("VXPayAboOverview::open()"), t.paymentFrame.then(function (o) {
              return o.sendOptions(Object.assign({}, e.defaultFlowOptions(), n)).sendAdditionalOptions(t.config.getAdditionalOptions()).changeRoute(wr.ABO_OVERVIEW).initSession();
            }), t.config.route = wr.ABO_OVERVIEW, t;
          }
        }], (n = null) && Ti(t.prototype, n), o && Ti(t, o), e;
      }();
      function Ai(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var Pi = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }
        var t, n, o;
        return t = e, o = [{
          key: "init",
          value: function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            return e.logger.log("VXPayInitForTab::init()"), e.config.enableTab && e.config.merge(Object.assign(t, {
              flowParams: Object.assign({}, t, n)
            })), e;
          }
        }], (n = null) && Ai(t.prototype, n), o && Ai(t, o), e;
      }();
      function Ii(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      var Ni = function () {
        function e(t) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this.config = t, this.logger = new K(this.config.logging, this.config.window), this._state = new mr(), this._hooks = new So(), this.logger.log("VXPay::constructor - " + JSON.stringify(this.config.getOptions())), this.hooksRouteHandler = this.routeHooks.bind(this), this.dontListenHandler = this.stopListening.bind(this);
        }
        var t, n, o;
        return t = e, n = [{
          key: "initHelperFrame",
          value: function () {
            var e = this;
            return new Promise(function (t) {
              return Ho.init(e, t);
            });
          }
        }, {
          key: "_initPaymentFrame",
          value: function () {
            var e = this,
              t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
            return this.logger.log("VXPay::_initPaymentFrame", t), new Promise(function (n) {
              return Si.init(e, n, t);
            });
          }
        }, {
          key: "openLogin",
          value: function () {
            var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return new Promise(function (n, o) {
              return e._initPaymentFrame().then(function (e) {
                return Pi.init(e, Sr.defaultFlowOptions(), t);
              }).then(Oi.reset).then(li.trigger).then(wi.tokenTransferred).then(function (e) {
                return Sr.open(e, t);
              }).then(n).catch(o);
            });
          }
        }, {
          key: "openSignUp",
          value: function () {
            var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return new Promise(function (n, o) {
              return e._initPaymentFrame().then(function (e) {
                return Pi.init(e, kr.defaultFlowOptions(), t);
              }).then(Oi.reset).then(li.trigger).then(wi.tokenTransferred).then(function (e) {
                return kr.open(e, t);
              }).then(n).catch(o);
            });
          }
        }, {
          key: "openVoiceCall",
          value: function () {
            var e = this;
            return new Promise(function (t, n) {
              e._initPaymentFrame().then(function (e) {
                return Pi.init(e, Nr.defaultFlowOptions());
              }).then(Oi.reset).then(li.trigger).then(wi.tokenTransferred).then(Nr.open).then(t).catch(n);
            });
          }
        }, {
          key: "openSignUpOrLogin",
          value: function () {
            var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return this.initHelperFrame().then(function (e) {
              return e.helperFrame.getLoginCookie();
            }).then(function (n) {
              return n.hasCookie ? e.openLogin(t) : e.openSignUp(t);
            });
          }
        }, {
          key: "openPayment",
          value: function () {
            var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return new Promise(function (n, o) {
              e._initPaymentFrame().then(function (e) {
                return Pi.init(e, Fr.defaultFlowOptions(), t);
              }).then(Oi.reset).then(li.trigger).then(wi.tokenTransferred).then(function (e) {
                return Fr.open(e, t);
              }).then(n).catch(o);
            });
          }
        }, {
          key: "openAbo",
          value: function () {
            var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return new Promise(function (n, o) {
              e._initPaymentFrame().then(function (e) {
                return Pi.init(e, Dr.defaultFlowOptions(), t);
              }).then(Oi.reset).then(li.trigger).then(wi.tokenTransferred).then(function (e) {
                return Dr.open(e, t);
              }).then(n).catch(o);
            });
          }
        }, {
          key: "openAboOverview",
          value: function () {
            var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return new Promise(function (n, o) {
              e._initPaymentFrame().then(function (e) {
                return Pi.init(e, ki.defaultFlowOptions(), t);
              }).then(Oi.reset).then(li.trigger).then(wi.tokenTransferred).then(function (e) {
                return ki.open(e, t);
              }).then(n).catch(o);
            });
          }
        }, {
          key: "openSettings",
          value: function () {
            var e = this;
            return new Promise(function (t, n) {
              e._initPaymentFrame().then(function (e) {
                return Pi.init(e, jr.defaultFlowOptions());
              }).then(Oi.reset).then(li.trigger).then(wi.tokenTransferred).then(jr.open).then(t).catch(n);
            });
          }
        }, {
          key: "resetPassword",
          value: function () {
            var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return new Promise(function (n, o) {
              e._initPaymentFrame().then(function (e) {
                return Pi.init(e, Ur.defaultFlowOptions(e.config), t);
              }).then(Oi.reset).then(li.trigger).then(wi.tokenTransferred).then(function (e) {
                return Ur.run(e, t);
              }).then(n).catch(o);
            });
          }
        }, {
          key: "lostPassword",
          value: function () {
            var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return new Promise(function (n, o) {
              e._initPaymentFrame().then(function (e) {
                return Pi.init(e, Hr.defaultFlowOptions(e.config), t);
              }).then(Oi.reset).then(li.trigger).then(wi.tokenTransferred).then(function (e) {
                return Hr.run(e, t);
              }).then(n).catch(o);
            });
          }
        }, {
          key: "limitPayment",
          value: function () {
            var e = this;
            return new Promise(function (t, n) {
              e._initPaymentFrame().then(function (e) {
                return Pi.init(e, Br.defaultFlowOptions());
              }).then(Oi.reset).then(li.trigger).then(wi.tokenTransferred).then(Br.open).then(t).catch(n);
            });
          }
        }, {
          key: "vipAboTrial",
          value: function () {
            var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return new Promise(function (n, o) {
              e._initPaymentFrame().then(function (e) {
                return Pi.init(e, Yr.defaultFlowOptions(), t);
              }).then(Oi.reset).then(li.trigger).then(wi.tokenTransferred).then(function (e) {
                return Yr.open(e, t);
              }).then(n).catch(o);
            });
          }
        }, {
          key: "premiumAbo",
          value: function () {
            var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return new Promise(function (n, o) {
              e._initPaymentFrame().then(function (e) {
                return Pi.init(e, Kr.defaultFlowOptions(), t);
              }).then(Oi.reset).then(li.trigger).then(wi.tokenTransferred).then(function (e) {
                return Kr.open(e, t);
              }).then(n).catch(o);
            });
          }
        }, {
          key: "openAVS",
          value: function () {
            var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return new Promise(function (n, o) {
              e._initPaymentFrame().then(function (e) {
                return Pi.init(e, zr.defaultFlowOptions(), t);
              }).then(Oi.reset).then(li.trigger).then(wi.tokenTransferred).then(function (e) {
                return zr.open(e, t);
              }).then(n).catch(o);
            });
          }
        }, {
          key: "openPromoCode",
          value: function () {
            var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return new Promise(function (n, o) {
              e._initPaymentFrame().then(function (e) {
                return Pi.init(e, Zr.defaultFlowOptions(), t);
              }).then(Oi.reset).then(li.trigger).then(wi.tokenTransferred).then(function (e) {
                return Zr.open(e, t);
              }).then(n).catch(o);
            });
          }
        }, {
          key: "openScratchCard",
          value: function () {
            var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return new Promise(function (n, o) {
              e._initPaymentFrame().then(function (e) {
                return Pi.init(e, Zr.defaultFlowOptions(), t);
              }).then(Oi.reset).then(li.trigger).then(wi.tokenTransferred).then(function (e) {
                return Zr.open(e, t);
              }).then(n).catch(o);
            });
          }
        }, {
          key: "openOneClick",
          value: function () {
            var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return new Promise(function (n, o) {
              e._initPaymentFrame().then(function (e) {
                return Pi.init(e, ei.defaultFlowOptions(), t);
              }).then(Oi.reset).then(li.trigger).then(wi.tokenTransferred).then(function (e) {
                return ei.run(e, t);
              }).then(n).catch(o);
            });
          }
        }, {
          key: "openAutoReCharge",
          value: function () {
            var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return new Promise(function (n, o) {
              e._initPaymentFrame().then(function (e) {
                return Pi.init(e, oi.defaultFlowOptions(), t);
              }).then(Oi.reset).then(li.trigger).then(wi.tokenTransferred).then(function (e) {
                return oi.run(e, t);
              }).then(n).catch(o);
            });
          }
        }, {
          key: "openBalance",
          value: function () {
            var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return new Promise(function (n, o) {
              e._initPaymentFrame().then(function (e) {
                return Pi.init(e, ii.defaultFlowOptions(), t);
              }).then(Oi.reset).then(li.trigger).then(wi.tokenTransferred).then(function (e) {
                return ii.open(e, t);
              }).then(n).catch(o);
            });
          }
        }, {
          key: "openMigration",
          value: function () {
            var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return new Promise(function (n, o) {
              return e._initPaymentFrame().then(function (e) {
                return Pi.init(e, ai.defaultFlowOptions(), t);
              }).then(Oi.reset).then(li.trigger).then(wi.tokenTransferred).then(function (e) {
                return ai.open(e, t);
              }).then(n).catch(o);
            });
          }
        }, {
          key: "openTelegram",
          value: function () {
            var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return new Promise(function (n, o) {
              return e._initPaymentFrame().then(function (e) {
                return Pi.init(e, ci.defaultFlowOptions(), t);
              }).then(Oi.reset).then(li.trigger).then(wi.tokenTransferred).then(function (e) {
                return ci.open(e, t);
              }).then(n).catch(o);
            });
          }
        }, {
          key: "isLoggedIn",
          value: function () {
            var e = this;
            return new Promise(function (t, n) {
              e._initPaymentFrame(!e.config.enableTab).then(wi.tokenTransferred).then(function (e) {
                return di(e, t, n);
              }).catch(n);
            });
          }
        }, {
          key: "getAVSStatus",
          value: function () {
            var e = this;
            return new Promise(function (t, n) {
              return e._initPaymentFrame(!e.config.enableTab).then(wi.tokenTransferred).then(function (e) {
                return xo(e, t, n);
              }).then(Qo).catch(n);
            });
          }
        }, {
          key: "getBalance",
          value: function () {
            var e = this;
            return new Promise(function (t, n) {
              e._initPaymentFrame(!e.config.enableTab).then(wi.tokenTransferred).then(function (e) {
                return zo(e, t, n);
              }).then(tr).catch(n);
            });
          }
        }, {
          key: "getActiveAbos",
          value: function () {
            var e = this;
            return new Promise(function (t, n) {
              e._initPaymentFrame(!e.config.enableTab).then(wi.tokenTransferred).then(function (e) {
                return nr(e, t, n);
              }).then(sr).catch(n);
            });
          }
        }, {
          key: "logout",
          value: function () {
            var e = this;
            return new Promise(function (t, n) {
              e._initPaymentFrame().then(function (e) {
                return cr(e, t, n);
              }).then(br).catch(n);
            });
          }
        }, {
          key: "_reloadByConfig",
          value: function () {
            var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0;
            this._paymentFrame.url = this.config.getPaymentFrameUrl(), this._hooks.onContentLoaded(function () {
              return t(e);
            });
          }
        }, {
          key: "changeLanguage",
          value: function (e) {
            var t = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              o = a.getAvailable();
            if (o.indexOf(e) < 0) throw new TypeError("Please choose one of: ".concat(o.toString()));
            return this.config._language = e, this.state.isFrameOpen ? new Promise(function (e) {
              t._reloadByConfig(e);
            }).then(function (e) {
              return e._paymentFrame;
            }).then(function (e) {
              return e.sendOptions(Object.assign({}, {
                flow: t.config.flow
              }, n)).sendAdditionalOptions(t.config.getAdditionalOptions()).changeRoute(t.config.route).initSession();
            }).then(function (e) {
              return e.show();
            }) : new Promise(function (e) {
              e(t);
            });
          }
        }, {
          key: "routeHooks",
          value: function (e) {
            hi(this._hooks, e);
          }
        }, {
          key: "startListening",
          value: function () {
            w.addEvent(L.EVENT_MESSAGE, this.config.window, this.hooksRouteHandler), w.addEvent(L.EVENT_UNLOAD, this.config.window, this.dontListenHandler);
          }
        }, {
          key: "stopListening",
          value: function () {
            w.removeEvent(L.EVENT_MESSAGE, this.config.window, this.hooksRouteHandler), w.removeEvent(L.EVENT_UNLOAD, this.config.window, this.dontListenHandler);
          }
        }, {
          key: "state",
          get: function () {
            return this._state;
          }
        }, {
          key: "config",
          get: function () {
            return this._config;
          },
          set: function (e) {
            if (!(e instanceof B)) throw new TypeError("Please provide an instance of VXPayConfig!");
            void 0 !== this._logger && this._logger.log("VXPay::config -> ", e), this._config = e;
          }
        }, {
          key: "logger",
          get: function () {
            return this._logger;
          },
          set: function (e) {
            if (!(e instanceof K)) throw new TypeError("Please provide an instance of VXPayLogger!");
            this._logger = e;
          }
        }, {
          key: "apiVersion",
          get: function () {
            return this.config.apiVersion;
          },
          set: function (e) {
            this.config.apiVersion = e;
          }
        }, {
          key: "hooks",
          get: function () {
            var e = this;
            return new Promise(function (t) {
              return t(e._hooks);
            });
          }
        }, {
          key: "paymentFrame",
          get: function () {
            var e = this;
            return new Promise(function (t, n) {
              e._initPaymentFrame().then(function (e) {
                return t(e._paymentFrame);
              }).catch(n);
            });
          },
          set: function (e) {
            if (!(e instanceof jo || e instanceof Uo)) throw new TypeError("Payment frame should be an instance of VXPayPaymentFrame or VXPayPaymentTab");
            this._paymentFrame = e;
          }
        }, {
          key: "helperFrame",
          get: function () {
            return this._helperFrame;
          },
          set: function (e) {
            if (!(e instanceof Bn)) throw new TypeError("Helper frame should be an instance of VXPayHelperFrame");
            this._helperFrame = e;
          }
        }, {
          key: "window",
          get: function () {
            return this.config.window;
          }
        }], n && Ii(t.prototype, n), o && Ii(t, o), e;
      }();
      var Ci = function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e);
      };
      Ci.SESSION_ACKNOWLEDGE = "ackSession", Ci.SESSION_EXPIRED = "sessionExpired", Ci.MESSAGE = "message", Ci.MESSAGE_PRICE = "messagePrice", Ci.CHANNELS = "channels", Ci.INCOMING_MESSAGE = "incomingMessage", Ci.ALL_CHANNELS_SEEN = "allChannelsSeen", Ci.CAN_ONECLICK_RESULT = "canOneClickResult", Ci.CHARGE_AUTORECHARGE_RESULT = "chargeAutoRechargeResult", Ci.CHARGE_ONECLICK_RESULT = "chargeOneClickResult", Ci.FAVORITE_ACTOR_PINNED = "FavoriteActorPinned", Ci.FAVORITE_ACTOR_UNPINNED = "FavoriteActorUnpinned", Ci.FAVORITE_PICTURE_PINNED = "FavoritePicturePinned", Ci.FAVORITE_PICTURE_UNPINNED = "FavoritePictureUnpinned", Ci.FAVORITE_ALBUM_PINNED = "FavoriteAlbumPinned", Ci.FAVORITE_ALBUM_UNPINNED = "FavoriteAlbumUnpinned", Ci.FAVORITE_SEDCARDS_ALBUM_PINNED = "FavoriteSedcardsAlbumPinned", Ci.FAVORITE_SEDCARDS_ALBUM_UNPINNED = "FavoriteSedcardsAlbumUnpinned", Ci.FAVORITE_ACTORS = "FavoriteActors", Ci.GUEST_BALANCE = "guestBalance", Ci.NAVBAR_NOTIFICATIONS = "navbarNotifications", Ci.ACTOR_ONLINE = "actorOnline", Ci.ACTOR_OFFLINE = "actorOffline", Ci.AVS_REVOKED = "avsRevoked", Ci.AVS_SET = "avsSet", Ci.GUEST_LOCKED = "guestLocked", Ci.CHANNEL_ARCHIVED = "channelArchived", Ci.SEND_SIGNUP_EMAIL_RESULT = "sendSignupEmailResult", Ci.VIP_ABO_UPDATE = "vipAboUpdate", Ci.VXTV_ABO_UPDATE = "vxtvAboUpdate", Ci.VOICECALL_START = "voicecallStart", Ci.VOICECALL_STOP = "voicecallStop", Ci.WELCOME_BONUS_REDEEMED = "welcomeBonusRedeemed", Ci.FREE_SHOW_START = "freeShowStart", Ci.FREE_SHOW_STOP = "freeShowStop", Ci.PONG = "pong";
      const Ri = Ci;
    })(), o;
  })();
});